/* DUO_UX_V29 */
var Shopify = Shopify || {};
/* ======================================================================
   COLLECT ALL SHOPIFY SECTION IDs
   ====================================================================== */
document.addEventListener('DOMContentLoaded', function () {

  const sectionIds = [];
  const sectionElements = document.querySelectorAll('[id^="shopify-section-"]');

  sectionElements.forEach(section => {
    const fullId = section.id;                        // shopify-section-123456
    const sectionId = fullId.replace('shopify-section-', '');
    sectionIds.push(sectionId);
  });

  // console.log("Loaded all Shopify Sections List:", sectionIds);
});






// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* ======================================================================
   Search POPUP OPEN CODE
   ====================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".search-drawer_popup");
  const closeBtn = document.querySelector(".search_popup_close");
  const popupWrapper = document.querySelector(".search_popup_wrapper");
  const popupInner = popupWrapper
    ? popupWrapper.querySelector(".search_popup_inner")
    : null;

  const html = document.documentElement;
  const body = document.body;

  if (!openBtn || !closeBtn || !popupWrapper || !popupInner) return;

  let lastFocusedElement = null;

  // Get all focusable elements inside popup
  function getFocusableElements() {
    return popupInner.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
  }

  function openSearchPopup() {
    lastFocusedElement = document.activeElement;

    // Lock scroll
    html.classList.add("lenis", "lenis-stopped");
    body.setAttribute("data-scroll-locked", "true");

    // Show popup
    popupWrapper.classList.add("serach_active");
    popupWrapper.setAttribute("aria-hidden", "false");

    // Wait for CSS transition / visibility
    requestAnimationFrame(() => {
      const focusable = getFocusableElements();
      if (focusable.length) {
        focusable[0].focus();
      } else {
        popupInner.setAttribute("tabindex", "-1");
        popupInner.focus();
      }
    });
  }

  function closeSearchPopup() {
    // Unlock scroll
    html.classList.remove("lenis-stopped");
    body.removeAttribute("data-scroll-locked");

    // Hide popup
    popupWrapper.classList.remove("serach_active");
    popupWrapper.setAttribute("aria-hidden", "true");

    // Restore focus
    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function trapFocus(e) {
    if (!popupWrapper.classList.contains("serach_active")) return;

    const focusable = getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  //  Outside click close (outside INNER only)
  function handleOutsideClick(e) {
    if (
      popupWrapper.classList.contains("serach_active") &&
      !popupInner.contains(e.target) &&
      !openBtn.contains(e.target)
    ) {
      closeSearchPopup();
    }
  }

  // Open popup
  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openSearchPopup();
  });

  // Close popup
  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closeSearchPopup();
  });

  // Keyboard handling
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popupWrapper.classList.contains("serach_active")) {
      closeSearchPopup();
    }
    trapFocus(e);
  });

  // Outside click listeners
  document.addEventListener("mousedown", handleOutsideClick);
  document.addEventListener("touchstart", handleOutsideClick);
});





/* ======================================================================
   ANNOUNCEMENT BAR SLIDER WEB COMPONENT
   ====================================================================== */
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Check if multiple slides exist
    const hasMultipleSlides = this.querySelectorAll(
      ".announcement-bar__item.swiper-slide"
    ).length > 1;

    if (!hasMultipleSlides) return;

    // Read data attributes
    const autoplay = this.dataset.autoplay === "true";
    const speed = parseInt(this.dataset.autoplaySpeed * 1000) || 3000;
    const fade = this.dataset.fade;
    let effect = fade === "true" ? "fade" : "slide";

    // Initialize Swiper
    const swiperContainer = this.querySelector(
      ".announcement-bar__inner.announcement-bar__inner--multiple"
    );

    if (!swiperContainer) return;

    whenSwiperReady(() => {
    new Swiper(swiperContainer, {
      loop: true,
      speed: 1000,
      grabCursor: true,
      autoplay: autoplay
        ? { delay: speed, disableOnInteraction: false }
        : false,
      effect: effect,
      fadeEffect: { crossFade: true },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 20 },
        640: { slidesPerView: 1 },
      },
    });
    });
  }
}

// Define custom element
customElements.define("announcement-bar", AnnouncementBar);


/* ======================================================================
    SLIDESHOW SLIDER WEB COMPONENT
   ====================================================================== */
class SlideshowSlider extends HTMLElement {
  constructor() {
    super();

    /* ===============================
       DATA ATTRIBUTES
    ================================ */
    this.sectionId = this.dataset.sectionId || "";
    this.spacing = Number(this.dataset.spacing) || 0;
    this.autoplay = this.dataset.autoplay === "true";
    this.speed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || "slide";

    /* ===========  SELECTORS (UPDATED) ========== */
    this.slider = this.querySelector(
      `.hero-slideshow__slider--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.hero-slideshow__next--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.hero-slideshow__prev--${this.sectionId}`
    );

    this.paginationEl = this.querySelector(
      `.swiper-pagination--${this.sectionId}`
    );

  }

  connectedCallback() {
    if (!this.slider) {
      console.warn(
        `Swiper container missing for section: ${this.sectionId}`
      );
      return;
    }

    /* =========== INIT SWIPER ================ */
    whenSwiperReady(() => {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: this.spacing,
        speed: 800,
        effect: this.effect,

        autoplay: this.autoplay
          ? {
              delay: this.speed,
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }
          : false,

        navigation:
          this.nextBtn && this.prevBtn
            ? {
                nextEl: this.nextBtn,
                prevEl: this.prevBtn,
              }
            : false,
            
        pagination:
          this.paginationEl
            ? {
                el: this.paginationEl,
                clickable: true,
              }
            : false,
      });
    });
    // console.log(`Swiper initialized for section: ${this.sectionId}`);
  }
  
}

customElements.define("slideshow-slider", SlideshowSlider);




/* ======================================================================
    Collection Slider WEB COMPONENT
   ====================================================================== */


class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    this.autoplayEnabled = this.dataset.autoplay === "true";
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed) * 1000 || 3000;
    this.effect = this.dataset.effect || "slide";

    this.slider = this.querySelector(".collection_slider_blocks_wrapper");
    this.wrapper = this.querySelector(".swiper-wrapper");
    this.mobileSlides = Number(this.dataset.mobileSlide) || 3;
    this.swiper = null;
  }

  connectedCallback() {
    if (!this.slider || !this.wrapper) return;
    if (this.swiper) return; //  prevent double init

    const totalSlides = this.wrapper.children.length;
    const isMobile = window.innerWidth < 1200;
    const forceSlider = this.dataset.forceSlider === "true";
    const centerSlides = this.dataset.centerSlides === "true";
    const spaceBetween = Number(this.dataset.spaceBetween) || 5;

    // Optional: avoid slider init if too few slides
    if (!isMobile && totalSlides < 12 && !forceSlider) return;

    whenSwiperReady(() => {
      this.swiper = new Swiper(this.slider, {
        speed: 800,
        spaceBetween,
        centerInsufficientSlides: centerSlides,
        effect: this.effect,

        //  A11Y FIX — NO LOOP
        loop: false,

        autoplay: this.autoplayEnabled
          ? {
              delay: this.autoplaySpeed,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,

        navigation: false,
        pagination: false,

        breakpoints: {
          0: { slidesPerView: this.mobileSlides },
          640: { slidesPerView: this.mobileSlides },
          768: { slidesPerView: 5 },
          990: { slidesPerView: 8 },
          1024: { slidesPerView: 8 },
          1200: { slidesPerView: 12 },
          1400: { slidesPerView: 12 },
        },
      });
    });
  }
}

customElements.define("collection-slider", CollectionSlider);




/* ======================================================================
    Before After WEB COMPONENT
   ====================================================================== */

    try {
    class SectionScaler extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            const vh = window.innerHeight,
                totalSlides = parseInt(this.dataset.totalInners, 10);
            let currentValue = 0,
                targetValue = 0,
                rafId = null;
            const updateInertia = () => {
                    (currentValue += (targetValue - currentValue) * 0.05),
                        this.style.setProperty("--animate-value", currentValue.toFixed(3)),
                        (rafId = requestAnimationFrame(updateInertia));
                },
                handleScroll = () => {
                    const sectionTop = this.offsetTop;
                    let section = (window.scrollY - sectionTop) / vh;
                    (section = Math.max(0, Math.min(section, totalSlides))), (targetValue = section);
                };
            (this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        entry.isIntersecting
                            ? (window.addEventListener("scroll", handleScroll, { passive: !0 }),
                              rafId || (rafId = requestAnimationFrame(updateInertia)))
                            : (window.removeEventListener("scroll", handleScroll),
                              rafId && (cancelAnimationFrame(rafId), (rafId = null)));
                    });
                },
                { root: null, rootMargin: "-10% 0px 0px 0px", threshold: 0 }
            )),
                this.observer.observe(this);
        }
    }
    customElements.get("section-scaler") || customElements.define("section-scaler", SectionScaler);
    } catch (e) {
    console.error(e);
    }
     
    

/* ======================================================================
    Tag Filter Section WEB COMPONENT
   ====================================================================== */
   
class TagFilterCode extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;

    this.filterBtn = this.querySelector(
      `#tagFilterBtn-${this.sectionId}`
    );

    this.dropdown1 = this.querySelector(
      `#tagDropdown1-${this.sectionId}`
    );

    this.dropdown2 = this.querySelector(
      `#tagDropdown2-${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.filterBtn || !this.dropdown1 || !this.dropdown2) return;

    this.filterBtn.addEventListener("click", () => {
      const tag1 = this.dropdown1.value;
      const tag2 = this.dropdown2.value;

      if (!tag1 && !tag2) return;

      let url = "/collections/all";

      if (tag1 && tag2) {
        url += `/${tag1}+${tag2}`;
      } else if (tag1) {
        url += `/${tag1}`;
      } else if (tag2) {
        url += `/${tag2}`;
      }

      window.location.href = url;
    });
  }
}

customElements.define("tag-filter-code", TagFilterCode);



/* ======================================================================
    VIDEO  Section WEB COMPONENT
   ====================================================================== */

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.playIcon = this.querySelector(".play_icon_wrapper");

    this.imageContainer = this.querySelector(
      ".video_section_poster_image_wrapper"
    );

    this.videoContainer = this.querySelector(".video_section_video_wrapper");
    this.video = this.videoContainer?.querySelector("video");
    this.iframe = this.videoContainer?.querySelector("iframe");
  }

  connectedCallback() {
    if (this.playIcon && this.imageContainer && this.videoContainer) {
      this.playIcon.addEventListener("click", this.handleClick);
    }
  }

  disconnectedCallback() {
    this.playIcon?.removeEventListener("click", this.handleClick);
  }

  handleClick = () => {
    if (!this.video && !this.iframe) return;

    this.imageContainer.classList.add("nodisp");

    setTimeout(() => {
      this.imageContainer.style.display = "none";
      this.videoContainer.style.display = "block";
      requestAnimationFrame(() => this.videoContainer.classList.add("disp"));

      if (this.video) {
        this.video.play();
      } else if (this.iframe) {
        const src = this.iframe.getAttribute("src");
        if (src.includes("youtube.com") || src.includes("youtu.be")) {
          this.iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        } else if (src.includes("vimeo.com")) {
          this.iframe.contentWindow.postMessage(
            '{"method":"play"}',
            "https://player.vimeo.com"
          );
        }
      }
    }, 500);
  };
}
customElements.define("video-section-block", VideoSection);

/* ======================================================================
    Review Slider Section WEB COMPONENT
   ====================================================================== */

   class ReviewSlider extends HTMLElement {
  constructor() {
    super();

    /* ===============================
       SECTION ID
    ================================ */
    this.sectionId = this.dataset.sectionId;

    /* ===============================
       SELECTORS (SCOPED)
    ================================ */
    this.slider = this.querySelector(
      `.review_row--${this.sectionId}`
    );

    this.pagination = this.querySelector(
      `.swiper-pagination--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.review_buttonNext--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.review_buttonPrev--${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.slider) return;

  whenSwiperReady(() => {
    this.swiper = new Swiper(this.slider, {
      effect: "cards",
      grabCursor: true,

      cardsEffect: {
        rotate: true,
        perSlideRotate: 4,
        perSlideOffset: 5,
        slideShadows: false,
      },

      pagination: this.pagination
        ? {
            el: this.pagination,
            clickable: true,
          }
        : false,

      navigation:
        this.nextBtn && this.prevBtn
          ? {
              nextEl: this.nextBtn,
              prevEl: this.prevBtn,
            }
          : false,

      initialSlide: 3,
      speed: 500,
    });
    });
  }
}

customElements.define("review-slider", ReviewSlider);


/* ======================================================================
    Product Tab Slider WEB COMPONENT
   ====================================================================== */

  class ProductTabSlider extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;

    this.thumbSlider = this.querySelector(
      `.productTab__steps_follow--${this.sectionId}`
    );

    this.mainSlider = this.querySelector(
      `.product_tab_slides--${this.sectionId}`
    );

    this.nextBtn = this.querySelector(
      `.productTab_button_next--${this.sectionId}`
    );

    this.prevBtn = this.querySelector(
      `.productTab_button_prev--${this.sectionId}`
    );
  }

  connectedCallback() {
    if (!this.thumbSlider || !this.mainSlider) return;

    whenSwiperReady(() => {
    this.thumbSwiper = new Swiper(this.thumbSlider, {
      spaceBetween: 20,
      slidesPerView: 8,
      freeMode: true,
      grabCursor: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },
      breakpoints: {
        320: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 15,
        },
      },
    });

    this.mainSwiper = new Swiper(this.mainSlider, {
      spaceBetween: 20,
      slidesPerView: 1,
      centeredSlides: true,
      autoHeight: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      thumbs: {
        swiper: this.thumbSwiper,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
    });
  }
}

customElements.define("product-tab-slider", ProductTabSlider);

   
/* ======================================================================
    Product Recommend filter Section WEB COMPONENT
   ====================================================================== */
  
class TagBasedRecommendation {
  constructor(sectionId) {

    /* ===============================
       DATA
    ================================ */
    this.sectionId = sectionId;
    this.section = document.querySelector(
      `[data-section-id="${sectionId}"]`
    );

    if (!this.section) return;

    /* ===============================
       ELEMENTS
    ================================ */
    this.dropdown1 = this.section.querySelector('[data-tag-dropdown="1"]');
    this.dropdown2 = this.section.querySelector('[data-tag-dropdown="2"]');
    this.button = this.section.querySelector('[data-tag-filter-btn]');

    if (!this.button) return;

    /* ===============================
       EVENTS
    ================================ */
    this.button.addEventListener('click', () => {
      this.handleRedirect();
    });
  }

  handleRedirect() {
    const tag1 = this.dropdown1?.value || '';
    const tag2 = this.dropdown2?.value || '';

    if (!tag1 && !tag2) return;

    let url = '/collections/all';

    if (tag1 && tag2) {
      url += `/${tag1}+${tag2}`;
    } else if (tag1) {
      url += `/${tag1}`;
    } else if (tag2) {
      url += `/${tag2}`;
    }

    window.location.href = url;
  }
}

document.querySelectorAll('[data-section-id]').forEach(section => {
  new TagBasedRecommendation(section.dataset.sectionId);
});

/* ======================================================================
    Product Card Slider Block COMPONENT
   ====================================================================== */

// function initProductCardSliders(scope = document) {
//   whenSwiperReady(() => {
//   const productCards = scope.querySelectorAll('[data-product-media-slider]');

//   if (!productCards.length) return;

//   productCards.forEach(function (card) {
//     const swiperEl = card.querySelector('.product-card-swiper');
//     const slides = swiperEl ? swiperEl.querySelectorAll('.swiper-slide') : [];
//     const thumbs = card.querySelectorAll('.product-thumb');

//     const prevBtn = card.querySelector('.product-card-prev');
//     const nextBtn = card.querySelector('.product-card-next');

//     // No slider needed → no errors
//     if (!swiperEl || slides.length < 2) {
//       if (prevBtn) prevBtn.style.display = 'none';
//       if (nextBtn) nextBtn.style.display = 'none';
//       return;
//     }

//     if (swiperEl.swiper) {
//       swiperEl.swiper.destroy(true, true);
//       swiperEl.swiper = null;
//     }

//     const swiper = new Swiper(swiperEl, {
//       effect: 'fade',
//       fadeEffect: {
//         crossFade: true
//       },
//       speed: 350,
//       slidesPerView: 1,
//       allowTouchMove: true,
//       watchSlidesProgress: true,
//       a11y: {
//         enabled: true
//       },
//       navigation: {
//         prevEl: prevBtn,
//         nextEl: nextBtn
//       }
//     });

    

//     // Thumbnail click
//     thumbs.forEach((thumb) => {
//       thumb.addEventListener('click', function () {
//         const index = Number(this.dataset.thumbIndex);
//         swiper.slideTo(index);

//         thumbs.forEach(t => {
//           t.classList.remove('is-active');
//           t.setAttribute('aria-selected', 'false');
//         });

//         this.classList.add('is-active');
//         this.setAttribute('aria-selected', 'true');
//       });
//     });

//     // Sync active thumb
//     swiper.on('slideChange', function () {
//       thumbs.forEach(t => {
//         t.classList.remove('is-active');
//         t.setAttribute('aria-selected', 'false');
//       });

//       if (thumbs[swiper.activeIndex]) {
//         thumbs[swiper.activeIndex].classList.add('is-active');
//         thumbs[swiper.activeIndex].setAttribute('aria-selected', 'true');
//       }
//     });
//   });
//    });
// }

function initProductCardSliders(scope = document) {

  whenSwiperReady(() => {

    const productCards = scope.querySelectorAll('[data-product-media-slider], [data-product-media-slider_main]');
    if (!productCards.length) return;

    productCards.forEach((card) => {

      const swiperEl = card.querySelector('.product-card-swiper');
      if (!swiperEl) return;

      const slides = swiperEl.querySelectorAll('.swiper-slide');

      const prevBtn = card.querySelector('.product-card-prev');
      const nextBtn = card.querySelector('.product-card-next');

      const productCard = card.closest('product-card');
      const thumbs = productCard ? productCard.querySelectorAll('.product-thumb') : [];

      // Hide navigation if only 1 image
      if (slides.length < 2) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      // Prevent double initialization
      if (swiperEl.classList.contains('swiper-initialized')) return;

      const swiper = new Swiper(swiperEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 350,
        slidesPerView: 1,
        allowTouchMove: true,
        watchSlidesProgress: true,
        a11y: {
          enabled: true
        },
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn
        }
      });

      /* ===============================
         Thumbnail Click
      =============================== */

      thumbs.forEach((thumb) => {

        thumb.addEventListener('click', function () {

          const index = Number(this.dataset.thumbIndex);

          swiper.slideTo(index);

          thumbs.forEach(t => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });

          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

        });

      });

      /* ===============================
         Sync active thumb with slider
      =============================== */

      swiper.on('slideChange', function () {

        thumbs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        if (thumbs[swiper.activeIndex]) {
          thumbs[swiper.activeIndex].classList.add('is-active');
          thumbs[swiper.activeIndex].setAttribute('aria-selected', 'true');
        }

      });

    });

  });

}



/* ======================================================================
    Featured collection Section WEB COMPONENT
   ====================================================================== */


class FeaturedCollection extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.featured-collection-swiper');
    if (!swiperEl) return;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    const desktop = parseInt(this.dataset.columns, 10) || 4;
    const smallDesktop = parseInt(this.dataset.smallcolumns, 10) || desktop;
    const mobile = parseInt(this.dataset.mobColumns, 10) || 2;
    const spacing = parseInt(this.dataset.spacing, 10) || 20;

    const paginationEl = this.querySelector('.mobil_swiper-pagination');

    whenSwiperReady(() => {
      this.swiper = new Swiper(swiperEl, {
        slidesPerView: mobile,
        spaceBetween: spacing,
        speed: 600,
        loop: false,

        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },

        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              enabled: true,
            }
          : false,

        breakpoints: {
          320: {
            slidesPerView: mobile,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          768: {
            slidesPerView: 2,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          1024: {
            slidesPerView: 3,
            spaceBetween: spacing,
            pagination: { enabled: true },
          },

          1500: {
            slidesPerView: desktop,
            spaceBetween: spacing,
            pagination: { enabled: false },
          },
        },
      });
    });
  }
}

customElements.define('featured-collection', FeaturedCollection);


/* ======================================================================
   Product Recommendations Component 
   ====================================================================== */


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;

    this.spacing = Number(this.dataset.spacing) || 20;
    this.columns = Number(this.dataset.columns) || 4;
    this.mobColumns = Number(this.dataset.mobColumns) || 1;
    this.type = this.dataset.type || 'default';

    this.handleObserver = this.handleObserver.bind(this);

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px 400px 0px",
    });
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleObserver(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      this.observer.disconnect();
      this.loadRecommendedProducts(
        this.recommendedURL,
        this.productId,
        this.sectionId
      );
    });
  }

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((res) => res.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;

        const recommendations = html.querySelector("product-recommendations");
        if (!recommendations || !recommendations.innerHTML.trim()) return;

        this.innerHTML = recommendations.innerHTML;

        //  FIX: support both default & complementary inner containers
        this.productsInner =
          this.querySelector(".product_recommendations_inner") ||
          this.querySelector(".complementary_products_inner");

        if (!this.productsInner) return;

        requestAnimationFrame(() => {
          this.initRecommendedSlider(
            this.productsInner,
            this.spacing,
            this.columns,
            this.mobColumns
          );
        });

        document.dispatchEvent(
          new CustomEvent("recommended-products-updated")
        );
      });
  }

  getSwiperBreakpoints(spacing, columns, mobColumns) {
    // COMPLEMENTARY PRODUCTS
    if (this.type === "complementary-products") {
      return {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        480: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 2.1,
          spaceBetween: 15,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      };
    }

    // DEFAULT PRODUCT RECOMMENDATIONS
    return {
      0: {
        slidesPerView: mobColumns,
        spaceBetween: 15,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: spacing,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: spacing,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: spacing,
      },
      1400: {
        slidesPerView: columns,
        spaceBetween: spacing,
      },
    };
  }

  initRecommendedSlider(inner, spacing, columns, mobColumns) {
  const prevBtn = this.querySelector(".pr_prev");
  const nextBtn = this.querySelector(".pr_next");

  //  pagination selectors
  const defaultPagination = this.querySelector(".rec-swiper-pagination");
  const complementaryPagination = this.querySelector(
    ".complementary-products_swiper-pagination"
  );

  if (inner.swiper) inner.swiper.destroy(true, true);

  const initSwiper = () => {
    new Swiper(inner, {
      slidesPerView: columns,
      spaceBetween: spacing,
      speed: 600,
      grabCursor: this.type === "complementary-products",
      watchOverflow: true,
      observer: true,
      observeParents: true,

      navigation:
        prevBtn && nextBtn && this.type !== "complementary-products"
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
            }
          : false,

      //  pagination logic per slider type
      pagination:
        this.type === "complementary-products" && complementaryPagination
          ? {
              el: complementaryPagination,
              clickable: true,
            }
          : defaultPagination
          ? {
              el: defaultPagination,
              clickable: true,
            }
          : false,

      breakpoints: this.getSwiperBreakpoints(
        spacing,
        columns,
        mobColumns
      ),
    });
  };

  // Safe Swiper init
  if (window.Swiper) {
    initSwiper();
  } else {
    document.addEventListener("swiper:loaded", initSwiper, { once: true });
  }
}
}

customElements.define("product-recommendations",  ProductRecommendations);





/* ======================================================================
   QuickAdd Component 
   ====================================================================== */


/* ======================== Quick view drawer open code ================== */
function openDrawer(drawerWrapper, triggerBtn) {
  if (!drawerWrapper) return;

  const drawerInner = drawerWrapper.querySelector('.quick_add-wrapper_inner');
  const closeBtn = drawerWrapper.querySelector('.quick_add_drawer_close');

  const focusableSelectors =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  // Save trigger
  drawerWrapper._triggerBtn = triggerBtn;

  /* -----------------------------
     OPEN STATE
  ----------------------------- */
  drawerWrapper.removeAttribute('inert');
  drawerWrapper.setAttribute('aria-hidden', 'false');
  drawerWrapper.classList.add('is-open');
  

  //  Scroll lock
  document.documentElement.classList.add('lenis', 'lenis-stopped');
  document.body.setAttribute('data-scroll-locked', 'true');
  document.body.classList.add('quick-add-open');

  // Focus first focusable (AFTER async content)
  setTimeout(() => {
    const focusables = drawerWrapper.querySelectorAll(focusableSelectors);
    (focusables[0] || drawerInner).focus();
  }, 50);

  /* -----------------------------
     KEYBOARD: ESC + FOCUS TRAP
  ----------------------------- */
  function handleKeydown(e) {
    if (e.key === 'Escape') {
      closeDrawer(drawerWrapper);
      return;
    }

    if (e.key !== 'Tab') return;

    //  Recalculate every time (fixes async content issue)
    const focusables = drawerWrapper.querySelectorAll(focusableSelectors);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  drawerWrapper.addEventListener('keydown', handleKeydown);
  drawerWrapper._handleKeydown = handleKeydown;

  /* -----------------------------
     OUTSIDE CLICK (INNER PANEL)
  ----------------------------- */
  function handleOutsideClick(e) {
    if (!drawerInner.contains(e.target) && e.target !== triggerBtn) {
      closeDrawer(drawerWrapper);
    }
  }

  setTimeout(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  }, 0);

  drawerWrapper._handleOutsideClick = handleOutsideClick;

  /* -----------------------------
     CLOSE BUTTON
  ----------------------------- */
  if (closeBtn) {
    closeBtn.addEventListener('click', () => closeDrawer(drawerWrapper));
  }
}

function closeDrawer(drawerWrapper) {
  if (!drawerWrapper) return;

  drawerWrapper.setAttribute('inert', '');
  drawerWrapper.setAttribute('aria-hidden', 'true');
  drawerWrapper.classList.remove('is-open');
  

  //  Unlock scroll
  document.documentElement.classList.remove('lenis', 'lenis-stopped');
  document.body.removeAttribute('data-scroll-locked');
  document.body.classList.remove('quick-add-open');

  // Cleanup listeners
  if (drawerWrapper._handleKeydown) {
    drawerWrapper.removeEventListener('keydown', drawerWrapper._handleKeydown);
  }

  if (drawerWrapper._handleOutsideClick) {
    document.removeEventListener('mousedown', drawerWrapper._handleOutsideClick);
    document.removeEventListener('touchstart', drawerWrapper._handleOutsideClick);
  }

  // Restore focus
  if (drawerWrapper._triggerBtn) {
    drawerWrapper._triggerBtn.focus();
  }
}



// ========== QUICK ADD CODE ============= //

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.dataset.productUrl;
    this.btn = this.querySelector('button');
    this.drawerWrapper = document.querySelector('.quick_add_slide')
    this.drawer = document.querySelector('.quick_add_side_inner');
    this.handleProductFetch = this.handleProductFetch.bind(this);
  }

  connectedCallback() {
    this.attachEventHandler();   
    
  }

  attachEventHandler() {
    if(this._isEventAttached) return;
    if(!this.btn) return;

    this._isEventAttached = true;
    this.btn.addEventListener('click', this.handleProductFetch)
  }

  showSkeleton() {
  this.drawer.innerHTML = `<div class="quick_add_block">Quick View </div>
  `;
}

  handleProductFetch() {
  this.showSkeleton();

  fetch(`${this.productUrl}`)
    .then((res) => res.text())
    .then((htmlString) => {
      const div = document.createElement('div');
      div.innerHTML = htmlString;

      const newHTML = div.querySelector('.main_product_main');
      if (!newHTML) return;

      const mainProduct = newHTML.querySelector('main-product-section');

      const originalSectionId = mainProduct.dataset.sectionId;
      const quickAddSectionId = `quick-add-${originalSectionId}`;

      // Replace IDs
      newHTML.innerHTML = newHTML.innerHTML.replaceAll(
        originalSectionId,
        quickAddSectionId
      );

      newHTML.querySelector('main-product-section').dataset.originalSectionId = originalSectionId;
      newHTML.querySelector('main-product-section').dataset.updateUrl = 'false';    
      
      const tabs = newHTML.querySelectorAll('.main_product_collapsible_wrapper');
      if(tabs) {
        tabs.forEach((tab) => {
          tab.remove();
        })
      }

      const pickup = newHTML.querySelector('.main_product_pickup_availability_wrapper');
      if(pickup) {
        pickup.remove();
      }

      const badges_block = newHTML.querySelector('.main_product_badges_block');
      if(badges_block) {
        badges_block.remove();
      }  
      
       const size_block = newHTML.querySelector('.main_product_size_chart');
      if(size_block) {
        size_block.remove();
      } 

      // Inject
      this.drawer.replaceChildren(...newHTML.children);
    });

    openDrawer(this.drawerWrapper, this.btn)
}

}

customElements.define('quick-add-to-cart', QuickAdd);




/* =============== Quick view call back function ================== */

document.addEventListener('collection-grid-update', () => {
  document.querySelectorAll('quick-add-to-cart').forEach((el) => {
    el.attachEventHandler();
  });
});




/* ======================================================================
   GIFT CARD 'recipient-form' Component JS
   ====================================================================== */

if (!customElements.get('recipient-form')) {
  class RecipientForm extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;

      this.checkbox = this.qs(`Recipient_checkbox`);
      this.hiddenControls = this.qs(`Recipient_control`);
      this.wrapper = this.querySelector('.recipients_input_wrapper');
      this.inner = this.wrapper?.querySelector('.recipients_input_inner');

      this.emailInput = this.qs(`Recipient_email`);
      this.nameInput = this.qs(`Recipient_name`);
      this.messageInput = this.qs(`Recipient_message`);
      this.sendonInput = this.qs(`Recipient_send_on`);
      this.offsetProperty = this.qs(`Recipient_timezone_offset`);

      if (this.checkbox) this.checkbox.disabled = false;
      if (this.hiddenControls) this.hiddenControls.disabled = true;

      if (this.offsetProperty) {
        this.offsetProperty.value = new Date().getTimezoneOffset().toString();
      }

      this.addEventListener('change', () => this.toggleWrapper());
    }

    qs(prefix) {
      return this.querySelector(`#${prefix}--${this.sectionId}`);
    }

    connectedCallback() {
      if (!this.inner || !this.wrapper) return;

      const height = this.inner.clientHeight;
      this.wrapper.style.setProperty('--height', `${height}px`);
    }

    toggleWrapper() {
      if (!this.checkbox || !this.wrapper) return;

      this.wrapper.toggleAttribute('open', this.checkbox.checked);
    }
  }

  customElements.define('recipient-form', RecipientForm);
}


/* ======================================================================
   MAIN PRODUCT PAGE Component 
   ====================================================================== */


//  ================= VARIANT PICKER =================
class VariantPicker extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.addEventListener('change', (e) => {
      this.selectedOptions = this.getSelectedOptions;
      
      this.dispatchEvent(
        new CustomEvent('variant-change', {
          detail: {
            selectedOptions: this.selectedOptions
          },
          bubbles: true
        })
      )
    })
  }

  get getSelectedOptions() {
      const selectValues = Array.from(this.querySelectorAll('select')).map((select) => {
        return select.selectedOptions[0].dataset.value;
      })

      const radioValues = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => {
        return input.dataset.value;
      })

      return [...selectValues, ...radioValues];
  }
}

customElements.define('variant-picker', VariantPicker);

class VariantSwatchDropdown extends HTMLElement {
  constructor() {
    super();
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('.variant_swatch_dropdown_trigger');
    this.panel = this.querySelector('.variant_swatch_dropdown_panel');
    this.search = this.querySelector('.variant_swatch_search');
    this.items = Array.from(this.querySelectorAll('.variant_swatch_dropdown_item'));
    this.preview = this.querySelector('.variant_swatch_dropdown_trigger_preview');
    this.triggerText = this.querySelector('.variant_swatch_dropdown_trigger_text');

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', () => this.togglePanel());
    this.search?.addEventListener('input', () => this.filterItems());
    this.search?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.stopPropagation();
        this.closePanel();
      }
    });

    this.querySelectorAll('.variant_swatch_dropdown_option').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.variant_swatch_dropdown_item');
        if (!item || button.disabled) return;
        this.selectItem(item);
      });
    });

    this.querySelectorAll('.variant_swatch_radio').forEach((input) => {
      input.addEventListener('change', () => this.syncFromCheckedRadio());
    });

    this.syncFromCheckedRadio();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  togglePanel() {
    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.closePanel();
    } else {
      this.openPanel();
    }
  }

  openPanel() {
    this.trigger.setAttribute('aria-expanded', 'true');
    this.panel.hidden = false;
    if (this.search) {
      this.search.value = '';
      this.filterItems();
      this.search.focus();
    }
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  closePanel() {
    this.trigger.setAttribute('aria-expanded', 'false');
    this.panel.hidden = true;
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closePanel();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closePanel();
      this.trigger.focus();
    }
  }

  filterItems() {
    const query = (this.search?.value || '').trim().toLowerCase();
    this.items.forEach((item) => {
      const searchText = (item.dataset.search || item.dataset.label || '').toLowerCase();
      item.classList.toggle('is-hidden', query !== '' && !searchText.includes(query));
    });
  }

  selectItem(item) {
    const radioId = item.dataset.radioId;
    const radio = radioId ? this.querySelector(`#${CSS.escape(radioId)}`) : null;
    if (!radio || radio.disabled) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    this.syncFromCheckedRadio();
    this.closePanel();
  }

  syncFromCheckedRadio() {
    const checked = this.querySelector('.variant_swatch_radio:checked');
    if (!checked) return;

    this.items.forEach((item) => {
      const isSelected = item.dataset.radioId === checked.id;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    const selectedItem = this.items.find((item) => item.dataset.radioId === checked.id);
    if (!selectedItem) return;

    const label = selectedItem.dataset.label || checked.value;
    if (this.triggerText) {
      this.triggerText.textContent = label;
    }

    const thumb = selectedItem.querySelector('.variant_swatch_dropdown_thumb');
    if (this.preview && thumb) {
      this.preview.innerHTML = thumb.innerHTML;
    }
  }
}

customElements.define('variant-swatch-dropdown', VariantSwatchDropdown);





//  ================= PRODUCT PICKUP DROP-DOWN  =================
document.addEventListener('click', function (e) {
  const toggleBtn = e.target.closest('.accordion_open_btn_pickup');
  if (!toggleBtn) return;

  const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
  const drawer = wrapper?.querySelector('.pickup_availability_drawer');

  if (!wrapper || !drawer) return;

  const isOpen = wrapper.classList.contains('is-open');

  wrapper.classList.toggle('is-open', !isOpen);
  drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
  toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
});


//  ================= QUANTITY PICKER =================
class QuantityPicker extends HTMLElement {
  constructor() {
    super();

    this.minusBtn = this.querySelector('[data-minus]');
    this.plusBtn  = this.querySelector('[data-plus]');
    this.input    = this.querySelector('input[type="text"]');

    if (!this.input) return;

    this.step = Number(this.input.step) || 1;
    this.min  = Number(this.input.dataset.min) || 1;
    this.max  = this.input.dataset.max ? Number(this.input.dataset.max) : null;

    this.value = Number(this.input.value) || this.min;
  }

  connectedCallback() {
    if (!this.input || !this.minusBtn || !this.plusBtn) return;

    this.minusBtn.addEventListener('click', () => this.change(-this.step));
    this.plusBtn.addEventListener('click', () => this.change(this.step));

    this.input.addEventListener(
      'input',
      this.debounce(() => {
        this.setValue(Number(this.input.value) || this.min);
      }, 600)
    );

    this.updateButtons();
  }

  /* -------- Value Logic -------- */

  change(amount) {
    this.setValue(this.value + amount);
  }

  setValue(val) {
    this.value = Math.min(
      this.max ?? Infinity,
      Math.max(this.min, val)
    );

    this.input.value = this.value;
    this.updateButtons();

    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: { value: this.value },
        bubbles: true
      })
    );
  }

  updateButtons() {
    this.minusBtn.disabled = this.value <= this.min;
    this.plusBtn.disabled  = this.max !== null && this.value >= this.max;
  }

  /* -------- Utils -------- */

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}

customElements.define('quantity-picker', QuantityPicker);


// =================  PRODUCT MEDIA  ================= //
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.yFrames = this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.vFrames = this.querySelectorAll('iframe[src*="vimeo.com"]');
    this.models = this.querySelectorAll('product-model');
  }

  connectedCallback() {
    if(this.videos.length) {
      this.videos.forEach((video) => {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleVdoClick(video);
        })
      })
    }

    if(this.yFrames.length) {
      this.yFrames.forEach((yFrame) => {
        yFrame.nextElementSibling.addEventListener('click', () => {
          yFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleYframeClick(yFrame);
        })
      })
    }

    if(this.vFrames.length) {
      this.vFrames.forEach((vFrame) => {
        vFrame.nextElementSibling.addEventListener('click', () => {
          vFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleVframeClick(vFrame);
        })
      })
    }

    if(this.models.length) {
      this.models.forEach((model) => {
        model.addEventListener('mouseenter', () => {
          if (typeof window.lenis !== 'undefined' && window.lenis?.stop) window.lenis.stop();
          document.documentElement.style.overflow = 'auto';
        })

        model.addEventListener('mouseleave', () => {
          if (typeof window.lenis !== 'undefined' && window.lenis?.start) window.lenis.start();
          document.documentElement.style.overflow = 'unset';
        })

        model.addEventListener('click', () => this.handleModelClick(model));
      })
    }
  }

  handleVdoClick(vdo) {
    this.pauseAllMedia(vdo);
    vdo.nextElementSibling.classList.add('hide');
    if(vdo.paused) {
      vdo.play();
      vdo.nextElementSibling.classList.add('hide'); 
    } else {
      vdo.pause();
      vdo.nextElementSibling.classList.remove('hide');
    }
  }

  handleYframeClick(yFrame) {
    this.pauseAllMedia(yFrame);
    yFrame.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }

  handleVframeClick(vFrame) {
    this.pauseAllMedia(vFrame);
    vFrame.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  handleModelClick(model) {
    console.log('click')
    this.pauseAllMedia(model)
  }

  pauseAllMedia(except = null) {
    this.videos.forEach((vdo) => {
      if(vdo != except) {
        vdo.nextElementSibling.classList.remove('hide');
        vdo.pause();
      }
    })

    this.yFrames.forEach((yFrame) => {
      if (yFrame !== except) {
        yFrame.nextElementSibling.style.pointerEvents = 'all';
        yFrame.contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
          "*"
        );
      }
    });

    this.vFrames.forEach((vFrame) => {
      if (vFrame !== except) {
        vFrame.nextElementSibling.style.pointerEvents = 'all';
        vFrame.contentWindow.postMessage({ method: "pause" }, "*");
      }
    });

    this.models.forEach((model) => {
      if(model !== except) {
        const modelViewer = model.querySelector('model-viewer');

        if(!modelViewer) return;
        if (model.modelViewerUI) model.modelViewerUI.pause();
      }
    })
  }
}

customElements.define('product-media', ProductMedia);

// ================= Mobile VIEW  ================= //
class ProductMobileMedia extends HTMLElement {
  constructor() {
    super();

    this.mobmainSlider  = this.querySelector('.product_slider_main_media');
    this.mobthumbSlider = this.querySelector('.product_slider_view_thumbnail_media');
    this.spacing        = this.dataset.spacing || 0;

    this.videos         = [...this.querySelectorAll('video')];
    this.youtubeFrames  = [...this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]')];
    this.vimeoFrames    = [...this.querySelectorAll('iframe[src*="vimeo.com"]')];
    this.models         = [...this.querySelectorAll('product-model')];
  }

  connectedCallback() {
    if (!this.mobmainSlider) return;

    this.initSwiper();
    this.initVideos();
    this.initYouTube();
    this.initVimeo();
    this.initModels();
  }

  /* ---------------- Swiper ---------------- */

  initSwiper() {
    if (this.mainSwiper) return;

    whenSwiperReady(() => {
      this.mainSwiper?.destroy(true, true);
      this.thumbSwiper?.destroy(true, true);

      if (this.mobthumbSlider) {
        this.thumbSwiper = new Swiper(this.mobthumbSlider, {
          direction: 'horizontal',
          slidesPerView: 5,
          spaceBetween: 5,
          speed: 400,
          watchSlidesProgress: true,
          watchOverflow: true,
          breakpoints: {
            1360: {
              direction: 'horizontal',
              slidesPerView: 7
            }
          }
        });
      }

      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      this.mainSwiper = new Swiper(this.mobmainSlider, {
        slidesPerView: 1,
        spaceBetween: Number(this.spacing) || 0,
        speed: 400,
        /* autoHeight causes iOS Safari layout thrash / tab crashes with large galleries */
        autoHeight: false,
        grabCursor: true,
        watchOverflow: true,
        resistanceRatio: 0.65,
        touchStartPreventDefault: false,
        /* cssMode is more stable for horizontal galleries on iOS Safari */
        cssMode: isIOS,
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next')
        },
        thumbs: this.thumbSwiper ? { swiper: this.thumbSwiper } : undefined
      });

      this.guardFancyboxDuringSwipe();
    });
  }

  guardFancyboxDuringSwipe() {
    if (!this.mobmainSlider || this._swipeGuardBound) return;
    this._swipeGuardBound = true;

    let moved = false;
    this.mobmainSlider.addEventListener(
      'touchmove',
      () => {
        moved = true;
      },
      { passive: true }
    );
    this.mobmainSlider.addEventListener(
      'touchend',
      () => {
        window.setTimeout(() => {
          moved = false;
        }, 50);
      },
      { passive: true }
    );
    this.mobmainSlider.addEventListener(
      'click',
      (event) => {
        if (!moved) return;
        const link = event.target.closest('a[data-fancybox]');
        if (!link) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }


  /* ---------------- Videos ---------------- */

  initVideos() {
    this.videos.forEach(video => {
      ['click', 'touchend'].forEach(evt => {
        video.addEventListener(evt, e => {
          e.preventDefault();
          this.toggleVideo(video);
        });
      });
    });
  }

  toggleVideo(video) {
    this.pauseAll(video);

    const overlay = video.nextElementSibling;
    if (!overlay) return;

    if (video.paused) {
      video.play();
      overlay.classList.add('hide');
    } else {
      video.pause();
      overlay.classList.remove('hide');
    }
  }

  /* ---------------- YouTube ---------------- */

  initYouTube() {
    this.youtubeFrames.forEach(frame => {
      const overlay = frame.nextElementSibling;
      if (!overlay) return;

      ['click', 'touchend'].forEach(evt => {
        overlay.addEventListener(evt, () => {
          overlay.style.pointerEvents = 'none';
          this.pauseAll(frame);
          this.postYouTube(frame, 'playVideo');
        });
      });
    });
  }

  postYouTube(frame, action) {
    frame.contentWindow?.postMessage(
      JSON.stringify({ event: 'command', func: action, args: [] }),
      '*'
    );
  }

  /* ---------------- Vimeo ---------------- */

  initVimeo() {
    this.vimeoFrames.forEach(frame => {
      const overlay = frame.nextElementSibling;
      if (!overlay) return;

      ['click', 'touchend'].forEach(evt => {
        overlay.addEventListener(evt, () => {
          overlay.style.pointerEvents = 'none';
          this.pauseAll(frame);
          frame.contentWindow?.postMessage({ method: 'play' }, '*');
        });
      });
    });
  }

  /* ---------------- Models ---------------- */

  initModels() {
    this.models.forEach(model => {
      model.addEventListener('mouseenter', () => this.lockScroll());
      model.addEventListener('mouseleave', () => this.unlockScroll());
      model.addEventListener('touchstart', () => this.lockScroll());
      model.addEventListener('touchend', () => {
        this.unlockScroll();
        this.pauseAll(model);
      });
    });
  }

  lockScroll() {
    if (typeof window.lenis !== 'undefined' && window.lenis?.stop) window.lenis.stop();
    document.documentElement.style.overflow = 'auto';
    if (this.mainSwiper) this.mainSwiper.allowTouchMove = false;
  }

  unlockScroll() {
    if (typeof window.lenis !== 'undefined' && window.lenis?.start) window.lenis.start();
    document.documentElement.style.overflow = 'unset';
    if (this.mainSwiper) this.mainSwiper.allowTouchMove = true;
  }

  /* ---------------- Pause All ---------------- */

  pauseAll(except) {
    this.videos.forEach(v => {
      if (v !== except) {
        v.pause();
        v.nextElementSibling?.classList.remove('hide');
      }
    });

    this.youtubeFrames.forEach(f => {
      if (f !== except) {
        f.nextElementSibling && (f.nextElementSibling.style.pointerEvents = 'all');
        this.postYouTube(f, 'pauseVideo');
      }
    });

    this.vimeoFrames.forEach(f => {
      if (f !== except) {
        f.nextElementSibling && (f.nextElementSibling.style.pointerEvents = 'all');
        f.contentWindow?.postMessage({ method: 'pause' }, '*');
      }
    });

    this.models.forEach(model => {
      if (model !== except && model.modelViewerUI) {
        model.modelViewerUI.pause();
        model.querySelector('.shopify-model-viewer-ui__button')?.removeAttribute('hidden');
      }
    });
  }
}

customElements.define('product-slider-view-media', ProductMobileMedia);




//================= MAIN PRODUCT FUNCTION =================== //
class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.originalSectionId = this.dataset.originalSectionId;
    this.sectionId = this.dataset.sectionId;
    this.productUrl = this.dataset.productUrl;
    this.isMainProduct = this.dataset.mainProduct;
    this.btn = this.querySelector('.product_form_buy_button');
    this.baseUrl = this.dataset.baseUrl;
    this.rootSection = this.closest('.product-section');
  }

  connectedCallback() {
    this.addEventListener('variant-change', this.onVariantChange.bind(this));
    this.addEventListener('quantity-change', this.onQuantityChange.bind(this));
  }

  onQuantityChange(e) {
    const value = e.detail.value;
    const baseInput = this.querySelector('input[name="quantity"]');
    if(baseInput) {
      baseInput.value = value;
    }    
  }

  onVariantChange(e) {
    const selectedOptions = e.detail.selectedOptions;

    // Sync ATC input immediately so a fast click can't submit the previous shade.
    this.applyVariantIdFromOptions(selectedOptions);
    this.setVariantPending(true);

    this.requestURL = this.buildURL(selectedOptions);
    this.loadInfo(this.requestURL);
  }

  buildURL(options) {
    const params = [];
    if (options.length) {
      params.push(`option_values=${options.join(',')}`);
    }

    // Always request the product section only — full page HTML is multi-MB and lags ATC.
    const sectionId = this.originalSectionId || this.sectionId;
    return `${this.productUrl}?section_id=${encodeURIComponent(sectionId)}&${params.join('&')}`;
  }

  loadInfo(url) {
    if (this._variantAbort) {
      try {
        this._variantAbort.abort();
      } catch (_) {}
    }
    this._variantAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;

    fetch(url, this._variantAbort ? { signal: this._variantAbort.signal } : undefined)
      .then((res) => res.text())
      .then((htmlString) => {
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        this.updateContent(html);
      })
      .catch((err) => {
        if (err && err.name === 'AbortError') return;
        console.error('Variant update failed:', err);
      })
      .finally(() => {
        this.setVariantPending(false);
      });
  }

  setVariantPending(isPending) {
    this.classList.toggle('is-variant-pending', Boolean(isPending));
    const form = this.querySelector('product-form form');
    const btn = form?.querySelector('[type="submit"], .product_form_buy_button');
    if (btn) {
      if (isPending) {
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
      }
    }
  }

  applyVariantIdFromOptions(selectedOptions) {
    if (!Array.isArray(selectedOptions) || !selectedOptions.length) return;
    const mapEl = document.querySelector('[data-mglx-variant-map]');
    if (!mapEl) return;
    let map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (_) {
      return;
    }
    const key = selectedOptions.map(String).join(',');
    const variantId = map[key] || (selectedOptions.length === 1 ? map[String(selectedOptions[0])] : null);
    if (!variantId) return;
    this.setProductFormVariantId(variantId);
  }

  setProductFormVariantId(variantId) {
    const form = this.querySelector('product-form form');
    const input = form?.querySelector('input[name="id"]');
    if (input) input.value = variantId;
  }

  updateContent(html) {    
    const originalSectionId = this.dataset.originalSectionId;
    const container = html.querySelector('main-product-section');

    if(this.sectionId.includes('quick-add')) {
      const newSectionId = `quick-add-${originalSectionId}`;  
      
      if(!container) return;

      container.innerHTML = container.innerHTML.replaceAll(originalSectionId, newSectionId);
    }

    if (container) {
      container.dataset.sectionId = this.sectionId;
    }

    // UPDATE PRICE
    const oldPrice = this.querySelector(`#Price-${this.sectionId}`);
    const newPrice = html.querySelector(`#Price-${this.sectionId}`);

    if(oldPrice && newPrice) {
      oldPrice.innerHTML = newPrice.innerHTML;
    }

    // UPDATE SKU
    const oldSKU = this.querySelector(`#SKU-${this.sectionId}`)
    const newSKU = html.querySelector(`#SKU-${this.sectionId}`)

    if(oldSKU && newSKU) {
      oldSKU.innerHTML = newSKU.innerHTML;
    }

    // UPDATE VARIANT PICKER
    const oldVariantPicker = this.querySelector(`#Variant_picker-${this.sectionId}`);
    const newVariantPicker = html.querySelector(`#Variant_picker-${this.sectionId}`);

    if(oldVariantPicker && newVariantPicker) {
      oldVariantPicker.innerHTML = newVariantPicker.innerHTML;
    }

    // UPDATE INVENTORY
    const oldInventory = this.querySelector(`#Inventory-${this.sectionId}`);
    const newInventory = html.querySelector(`#Inventory-${this.sectionId}`);

    if(oldInventory && newInventory) {
      oldInventory.innerHTML = newInventory.innerHTML;
    }

    // UPDATE QUANTITY
    const oldQuantity = this.querySelector(`#Quantity-${this.sectionId}`);
    const newQuantity = html.querySelector(`#Quantity-${this.sectionId}`);

    if(oldQuantity && newQuantity) {
      oldQuantity.innerHTML = newQuantity.innerHTML;
    }

    // UPDATE QUOTE
    const oldQuote = this.querySelector(`#Quote-${this.sectionId}`);
    const newQuote = html.querySelector(`#Quote-${this.sectionId}`);

    if(oldQuote && newQuote) {
      oldQuote.innerHTML = newQuote.innerHTML;
    }

    // UPDATE PICKUP AVAILABILITY
    const oldPickup = this.querySelector(`#Pickup-${this.sectionId}`);
    const newPickup = html.querySelector(`#Pickup-${this.sectionId}`);

    if(newPickup && oldPickup) {
      oldPickup.innerHTML = newPickup.innerHTML;
    }

    // UPDATE ADD TO CART BUTTON
    const oldBtn = this.querySelector('product-form');
    const newBtn = html.querySelector('product-form');

    if(oldBtn && newBtn) {
      oldBtn.innerHTML = newBtn.innerHTML;
    }

    // UPDATE FEATURED MEDIA
    // const oldFeaturedMedia = this.querySelector(`#FeaturedMedia-${this.sectionId}`);
    // const newFeaturedMedia = html.querySelector(`#FeaturedMedia-${this.sectionId}`);

    
    // if(oldFeaturedMedia && newFeaturedMedia) {
    //   oldFeaturedMedia.innerHTML = newFeaturedMedia.innerHTML;
    // }

    // // UPDATE MOBILE MEDIA
    // const oldMedia = this.querySelector('.product_slider_wrapper');
    // const newMedia = html.querySelector('.product_slider_wrapper');

    // if(oldMedia && newMedia) {
    //   oldMedia.innerHTML = newMedia.innerHTML;
    // }

    const variantData = this.extractVariantData(html);

    if (variantData && variantData.available) {

      // UPDATE FEATURED MEDIA
      const oldFeaturedMedia = this.querySelector(`#FeaturedMedia-${this.sectionId}`);
      const newFeaturedMedia = html.querySelector(`#FeaturedMedia-${this.sectionId}`);

      if(oldFeaturedMedia && newFeaturedMedia) {
        oldFeaturedMedia.innerHTML = newFeaturedMedia.innerHTML;
      }

      // UPDATE MOBILE MEDIA
      const oldMedia = this.querySelector('.product_slider_wrapper');
      const newMedia = html.querySelector('.product_slider_wrapper');

      if(oldMedia && newMedia) {
        oldMedia.innerHTML = newMedia.innerHTML;
      }

    } else {
      //  Variant invalid or unavailable
      console.log('Media not updated - invalid/unavailable variant');
    }

    if(this.dataset.updateUrl === 'true') {
      this.updateURL(html);
    }    

    this.setMainInput(html);
  }
  
  extractVariantData(html) {
    const root = html || this;
    const el = root.querySelector?.('[data-selected-variant]') || this.querySelector('[data-selected-variant]');
    const data = el?.innerHTML?.trim();
    if (!data) return null;

    try {
      return JSON.parse(data);
    } catch (_) {
      return null;
    }
  }

  updateURL(html) {
    const variantData = this.extractVariantData(html) || this.extractVariantData(this);
    if(!variantData) return;

    window.history.replaceState(null, {}, `${this.productUrl}?variant=${variantData.id}`);
    this.handlePickup(variantData.id);
  }

  handlePickup(id) {
    let baseUrl = this.dataset.baseUrl;
    if(!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }

    fetch(`${baseUrl}variants/${id}/?section_id=pickup-availability-section`)
    .then((res) => res.text())
    .then((data) => {
      const container = document.querySelector('[data-store-availability-container]');
      const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.pickup_availability_wrapper');

      if(container && newHTML) {
        container.innerHTML = newHTML.innerHTML;
        initPickupAccordion(container);
        const pickUpDrawer = container.querySelector('pickup-availability-drawer');
        const pickUpBtn = container.querySelector('.accordion_open_btn_pickup');
        // Pickup CODE =============
        if(pickUpDrawer && pickUpBtn) {
          // pickUpBtn.addEventListener('click', () => {
          //   openDrawer(pickUpDrawer, pickUpBtn, this.rootSection);
          // })          
            if (!toggleBtn) return;

              const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
              const drawer = wrapper?.querySelector('.pickup_availability_drawer');

              if (!wrapper || !drawer) return;

              const isOpen = wrapper.classList.contains('is-open');

              wrapper.classList.toggle('is-open', !isOpen);
              drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
              toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          
        }

        if(pickUpDrawer) {
          if (!toggleBtn) return;

              const wrapper = toggleBtn.closest('.main_product_pickup_availability_wrapper');
              const drawer = wrapper?.querySelector('.pickup_availability_drawer');

              if (!wrapper || !drawer) return;

              const isOpen = wrapper.classList.contains('is-open');

              wrapper.classList.toggle('is-open', !isOpen);
              drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
              toggleBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        }
      }
    })

  }
  

  setMainInput(html) {
    const variantData = this.extractVariantData(html) || this.extractVariantData(this);
    if (!variantData) return;

    // Must target the ATC form — payment-terms also has input[name="id"] earlier in the DOM.
    this.setProductFormVariantId(variantData.id);
  }
}

customElements.define('main-product-section', MainProduct);


// ================= PRODUCT FORM  ================= //

class ProductatcForm extends HTMLElement {
  constructor() {
    super();
    this.submit = this.submit.bind(this);
    this.refresh = this.cache.bind(this);
  }

  connectedCallback() {
    this.cache();
    this.addEventListener('submit', this.submit);
    this.addEventListener('variant-change', this.refresh);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.submit);
    this.removeEventListener('variant-change', this.refresh);
  }

  cache() {
    this.form = this.querySelector('form');
    this.btn = this.querySelector('.product_form_buy_button');
    this.text = this.btn?.querySelector('.atc_status');
    this.load = this.btn?.querySelector('.loader');
    this.cart = document.querySelector('cart-contents');
    this.open = false;
  }

  async submit(e) {
    if (!e.target.closest('form')) return;

    e.preventDefault();
    e.stopPropagation(); // ← from reference, safe to add

    this.cache();
    if (!this.form || !this.btn) return;

    this.text.style.visibility = 'hidden';
    this.load.classList.remove('hidden');

    const formData = new FormData(this.form);

    try {
      const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      const data = await res.json();

      const refresh = async () => {
        const sections = await fetch(
          `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
        ).then(r => r.json());

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { sections },
            bubbles: true
          })
        );
      };

      if (!res.ok) {
        await refresh();
        throw data;
      }

      // if (this.cart) {
      //   await refresh();
      //   this.open = true;
      // } else {
      //   window.location.href = `${Shopify.routes.root}cart`;
      // }

      // =============== UPDATE CART FEATURE (update cart notification message) ==================//
      if (this.cart) {
          await refresh();

          // Check if popup mode enabled
          const popupBtn = document.querySelector('.cart_sidebar_open_btn-popup');

          if (popupBtn) {
            // Popup notification mode
            this.open = false;

            // Get current cart count
            let cartCount = 0;

            try {
              const res = await fetch(`${Shopify.routes.root}cart.js`);
              const cartData = await res.json();
              cartCount = cartData.item_count || 0;
            } catch (e) {
              console.error('Cart fetch error:', e);
            }

            const popup = document.querySelector('.cart-toast-popup');

            if (popup) {
              clearTimeout(popup.hideTimer);

              const countText = popup.querySelector('.cart-toast-text small');

              if (countText) {
                const template =
                  popup.dataset.message || '[count] [item] in cart';

                countText.textContent = template
                  .replace('[count]', cartCount)
                  .replace('[item]', cartCount === 1 ? 'item' : 'items');
              }

              popup.classList.remove('show');

              requestAnimationFrame(() => {
                popup.classList.add('show');
              });

              popup.hideTimer = setTimeout(() => {
                popup.classList.remove('show');
              }, 5000);
            }

          } else {
            // Normal cart drawer mode
            this.open = true;
          }

        } else {
          window.location.href = `${Shopify.routes.root}cart`;
        }

    } catch (err) {
      this.showError(err);
    } finally {
      this.text.style.visibility = 'visible';
      this.load.classList.add('hidden');

      // --- drawer behavior ---
      if (this.open && this.cart) {
        const openBtn = document.querySelector('.cart_sidebar_open_btn');
        if (openBtn) {
          openBtn.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true })
          );
        }
      }
    }
  }

   showError(data) {
  const error = this.querySelector('.product_add_error');
  if (!error) return;

  let message = 'Unable to add product to cart';

  if (data?.errors && typeof data.errors === 'object') {
    const formattedErrors = [];

    Object.entries(data.errors).forEach(([field, value]) => {
      // Human-friendly field names with fallback
      let fieldLabel = field === 'email' ? 'Email' : field;

      // Normalize message
      if (value === "can't be blank") {
        formattedErrors.push(`${fieldLabel} can't be blank`);
      } 
      else if (value === 'is invalid') {
        formattedErrors.push(`${fieldLabel} is invalid`);
      } 
      else if (fieldLabel === 'send_on'){
        formattedErrors.push(`Send on must be within 90 days from now`);
      }
      else {
        formattedErrors.push(`${fieldLabel} ${value}`);
      }
     
    });

    message = formattedErrors.join('<br>');
  }
  else if (typeof data?.errors === 'string') {
    message = data.errors;
  }
  else if (typeof data?.description === 'string') {
    message = data.description;
  }
  else if (typeof data?.message === 'string') {
    message = data.message;
  }

  error.innerHTML = message;
  error.classList.remove('hidden');
}

}

customElements.define('product-form', ProductatcForm);

class BxgyOfferBuilder extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    this.cart = document.querySelector('cart-contents');
    this.variants = this.parseVariants();
    this.panels = Array.from(this.querySelectorAll('[data-bxgy-panel]'));
    this.tabs = Array.from(this.querySelectorAll('[data-bxgy-tab]'));
    this.body = this.querySelector('[data-bxgy-body]');
    this.collapseBtn = this.querySelector('[data-bxgy-collapse]');
    this.mobileQuery = window.matchMedia('(max-width: 768px)');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateOffer(tab.dataset.bxgyTab));
    });
    this.collapseBtn?.addEventListener('click', () => this.collapse());

    this.panels.forEach((panel) => this.setupPanel(panel));

    this.syncLayoutMode();
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', () => this.syncLayoutMode());
    } else if (this.mobileQuery.addListener) {
      this.mobileQuery.addListener(() => this.syncLayoutMode());
    }
  }

  isMobile() {
    return this.mobileQuery.matches;
  }

  syncLayoutMode() {
    if (this.isMobile()) {
      this.collapse({ silent: true });
    } else if (!this.querySelector('[data-bxgy-tab].is-active') && this.tabs[0]) {
      this.activateOffer(this.tabs[0].dataset.bxgyTab, { scroll: false });
    }
  }

  parseVariants() {
    const el = this.querySelector('[data-bxgy-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return [];
    }
  }

  collapse(options = {}) {
    this.classList.add('is-collapsed');
    this.classList.remove('is-expanded');
    if (this.body) this.body.hidden = true;

    this.tabs.forEach((tab) => {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
    });

    if (!options.silent && this.isMobile()) {
      this.querySelector('.bxgy_builder_intro')?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }

  activateOffer(offerId, options = {}) {
    const scroll = options.scroll !== false;

    this.classList.remove('is-collapsed');
    this.classList.add('is-expanded');
    if (this.body) this.body.hidden = false;

    this.tabs.forEach((tab) => {
      const active = tab.dataset.bxgyTab === String(offerId);
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.offerId === String(offerId);
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    if (scroll && this.isMobile()) {
      this.body?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setupPanel(panel) {
    const selects = Array.from(panel.querySelectorAll('[data-bxgy-select]'));
    const addButton = panel.querySelector('[data-bxgy-add]');

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        this.onSlotChange(panel, selects);
      });
    });

    addButton?.addEventListener('click', () => this.addOffer(panel, selects, addButton));
    this.updatePanelState(panel, selects);
  }

  onSlotChange(panel, selects) {
    this.updatePanelState(panel, selects);
  }

  getSelectedVariantIds(selects) {
    return selects.map((select) => select.value).filter(Boolean).map(Number);
  }

  formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const format = this.dataset.moneyFormat || '{{amount}}';
    if (format.includes('{{amount_no_decimals}}')) {
      return format.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    if (format.includes('{{amount}}')) {
      return format.replace('{{amount}}', amount);
    }
    return amount;
  }

  updatePanelState(panel, selects) {
    const totalSlots = Number(panel.dataset.totalSlots || selects.length);
    const getQty = Number(panel.dataset.getQty || 0);
    const selectedIds = this.getSelectedVariantIds(selects);
    const filled = selectedIds.length;

    const progressText = panel.querySelector('[data-bxgy-progress-text]');
    const progressFill = panel.querySelector('[data-bxgy-progress-fill]');
    if (progressText) progressText.textContent = `${filled} / ${totalSlots} selected`;
    if (progressFill) {
      progressFill.style.width = `${Math.min(100, (filled / Math.max(totalSlots, 1)) * 100)}%`;
    }

    const pricing = panel.querySelector('[data-bxgy-pricing]');
    const savingsEl = panel.querySelector('[data-bxgy-savings]');
    const totalEl = panel.querySelector('[data-bxgy-total]');
    const compareEl = panel.querySelector('[data-bxgy-compare]');
    const addButton = panel.querySelector('[data-bxgy-add]');

    let compare = 0;
    selectedIds.forEach((id) => {
      const variant = this.variants.find((entry) => Number(entry.id) === Number(id));
      if (variant) compare += Number(variant.price || 0);
    });

    const prices = selectedIds
      .map((id) => {
        const variant = this.variants.find((entry) => Number(entry.id) === Number(id));
        return Number(variant?.price || 0);
      })
      .sort((a, b) => a - b);

    let savings = 0;
    if (filled === totalSlots && getQty > 0) {
      savings = prices.slice(0, getQty).reduce((sum, price) => sum + price, 0);
    }

    const total = Math.max(0, compare - savings);

    if (pricing) pricing.hidden = filled === 0;
    if (savingsEl) {
      savingsEl.textContent = savings > 0 ? `Save ${this.formatMoney(savings)}` : '';
      savingsEl.hidden = savings <= 0;
    }
    if (totalEl) totalEl.textContent = this.formatMoney(total);
    if (compareEl) {
      compareEl.textContent = this.formatMoney(compare);
      compareEl.hidden = savings <= 0;
    }

    if (addButton) addButton.disabled = filled !== totalSlots;
  }

  setLoading(button, isLoading) {
    const text = button.querySelector('.bxgy_add_btn_text');
    const loader = button.querySelector('.loader');
    if (text) text.style.visibility = isLoading ? 'hidden' : 'visible';
    loader?.classList.toggle('hidden', !isLoading);
    button.dataset.loading = isLoading ? 'true' : 'false';
  }

  showError(panel, message) {
    const error = panel.querySelector('[data-bxgy-error]');
    if (!error) return;
    error.textContent = message;
    error.classList.remove('hidden');
  }

  clearError(panel) {
    const error = panel.querySelector('[data-bxgy-error]');
    if (!error) return;
    error.textContent = '';
    error.classList.add('hidden');
  }

  buildItems(selects) {
    const ids = this.getSelectedVariantIds(selects);
    if (!ids.length) return null;

    const qtyMap = new Map();
    ids.forEach((id) => {
      qtyMap.set(id, (qtyMap.get(id) || 0) + 1);
    });

    return Array.from(qtyMap.entries()).map(([id, quantity]) => ({ id, quantity }));
  }

  async refreshCartSections() {
    const sections = await fetch(
      `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
    ).then((response) => response.json());

    document.dispatchEvent(
      new CustomEvent('cart-update', {
        detail: { sections },
        bubbles: true
      })
    );
  }

  openCartDrawer() {
    const openBtn = document.querySelector('.cart_sidebar_open_btn');
    if (openBtn) {
      openBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  }

  async addOffer(panel, selects, button) {
    const items = this.buildItems(selects);
    if (!items || items.length === 0) {
      this.showError(panel, 'Select a shade for every slot.');
      return;
    }

    this.clearError(panel);
    const wasDisabled = button.disabled;
    this.setLoading(button, true);
    button.disabled = true;

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok) throw data;

      await this.refreshCartSections();

      if (this.cart) {
        this.openCartDrawer();
      } else {
        window.location.href = `${Shopify.routes.root}cart`;
      }
    } catch (error) {
      const message =
        typeof error?.description === 'string'
          ? error.description
          : typeof error?.message === 'string'
            ? error.message
            : 'Could not add this offer. Please try again.';
      this.showError(panel, message);
    } finally {
      this.setLoading(button, false);
      this.updatePanelState(panel, selects);
      if (!wasDisabled && this.getSelectedVariantIds(selects).length === selects.length) {
        button.disabled = false;
      }
    }
  }
}

customElements.define('bxgy-offer-builder', BxgyOfferBuilder);

class ProductDuoBuilder extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;
    // Children may not be parsed yet when the custom element upgrades.
    queueMicrotask(() => this.init());
  }

  init() {
    if (this._initialized) return;
    this._initialized = true;

    this.pairs = this.parseJSON('[data-duo-pairs]') || [];
    this.variantsA = [];
    this.variantsB = [];
    this.offers = this.parseJSON('[data-duo-offers]') || { a: [], b: [] };

    this.cacheElements();
    this.applyVariantLayout();

    this.rows = [];
    this.ready = false;
    this.aPickerQuery = '';
    this.bSelectedPairId = null;
    this.bPickerQuery = '';

    this.atcBtn?.addEventListener('click', () => this.handleAtcClick());
    this.bAddBtn?.addEventListener('click', () => this.addBSelectedPair());

    this.bindSummaryLift();
    this.bindPickerScrollClose();
    this.hydrateProducts();
  }

  applyVariantLayout() {
    const params = new URLSearchParams(window.location.search);
    this.layoutVariant = params.get('v') === 'b' ? 'b' : 'a';
    this.dataset.duoVariant = this.layoutVariant;

    const page = this.closest('.duo-page');
    page?.classList.toggle('duo-page--b', this.layoutVariant === 'b');
    page?.classList.toggle('duo-page--a', this.layoutVariant !== 'b');

    const showB = this.layoutVariant === 'b';
    this.querySelectorAll('[data-duo-layout-a]').forEach((node) => {
      node.hidden = showB;
    });
    page?.querySelectorAll('[data-duo-layout-a]').forEach((node) => {
      if (!this.contains(node)) node.hidden = showB;
    });
    if (this.layoutB) this.layoutB.hidden = !showB;
  }

  bindSummaryLift() {
    const summary = this.querySelector('[data-duo-summary]');
    if (!summary || this._summaryLiftBound) return;
    this._summaryLiftBound = true;

    const page = this.closest('.duo-page');
    const footer =
      document.querySelector('footer-section') ||
      document.querySelector('.footer-section') ||
      document.querySelector('[id*="footer"]') ||
      document.querySelector('footer');

    let ticking = false;
    const update = () => {
      ticking = false;
      const summaryH = summary.offsetHeight || 120;
      this.style.setProperty('--duo-summary-pad', `${summaryH + 20}px`);

      if (page) {
        const pageBottom = page.getBoundingClientRect().bottom;
        if (pageBottom <= summaryH + 12) {
          summary.classList.add('is-away');
          summary.style.setProperty('--duo-summary-lift', '0px');
          return;
        }
        summary.classList.remove('is-away');
      }

      if (!footer) {
        summary.style.setProperty('--duo-summary-lift', '0px');
        return;
      }

      const footerTop = footer.getBoundingClientRect().top;
      const overlap = Math.max(0, window.innerHeight - footerTop);
      const maxLift = Math.max(0, window.innerHeight - summaryH);
      const lift = Math.min(overlap, maxLift);
      summary.style.setProperty('--duo-summary-lift', `${lift}px`);
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(onScrollOrResize).observe(summary);
    }
    update();
  }

  closeOpenDuoPickers() {
    document.querySelectorAll('.duo-free-picker.is-open, .duo-b-picker.is-open').forEach((node) => {
      node.classList.remove('is-open', 'is-dropup');
      const owner = node.dataset.duoOwner;
      const panel =
        node.querySelector('.duo-free-picker__panel') ||
        (owner ? document.querySelector(`.duo-free-picker__panel[data-duo-owner="${owner}"]`) : null);
      const trigger = node.querySelector('.duo-free-picker__trigger');
      if (panel) this.unportalPickerPanel(node, panel);
      trigger?.setAttribute('aria-expanded', 'false');
    });
    this.setPickerOpenState(false);
  }

  setPickerOpenState(isOpen) {
    document.documentElement.classList.toggle('duo-picker-open', Boolean(isOpen));
    const summary = this.querySelector('[data-duo-summary]');
    if (summary) summary.classList.toggle('is-picker-open', Boolean(isOpen));
  }

  ensurePickerOwner(picker, panel) {
    if (!picker.dataset.duoOwner) {
      const id = `duo-picker-${Math.random().toString(16).slice(2, 10)}`;
      picker.dataset.duoOwner = id;
      panel.dataset.duoOwner = id;
    } else {
      panel.dataset.duoOwner = picker.dataset.duoOwner;
    }
  }

  portalPickerPanel(picker, panel) {
    this.ensurePickerOwner(picker, panel);
    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
    panel.classList.add('is-portaled');
    panel.hidden = false;
    this.setPickerOpenState(true);
  }

  unportalPickerPanel(picker, panel) {
    panel.hidden = true;
    panel.classList.remove('is-portaled');
    panel.style.position = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.top = '';
    panel.style.bottom = '';
    panel.style.width = '';
    panel.style.maxHeight = '';
    panel.style.zIndex = '';
    if (picker && panel.parentElement !== picker) {
      picker.appendChild(panel);
    }
    if (!document.querySelector('.duo-free-picker.is-open, .duo-b-picker.is-open')) {
      this.setPickerOpenState(false);
    }
  }

  placePortaledPanel(picker, panel, trigger, opts = {}) {
    this.portalPickerPanel(picker, panel);
    const triggerRect = trigger.getBoundingClientRect();
    const gap = 8;
    const preferred = opts.preferred || 280;
    // Size against the full viewport — the portaled panel stacks above the sticky bag.
    const spaceBelow = Math.max(0, window.innerHeight - triggerRect.bottom - gap);
    const spaceAbove = Math.max(0, triggerRect.top - gap);
    const openUp = spaceAbove >= 160 || spaceBelow < 200;
    const height = Math.min(
      preferred,
      openUp ? Math.max(160, spaceAbove) : Math.max(140, spaceBelow || preferred)
    );

    panel.style.position = 'fixed';
    panel.style.left = `${Math.max(8, Math.min(triggerRect.left, window.innerWidth - triggerRect.width - 8))}px`;
    panel.style.width = `${Math.min(Math.max(triggerRect.width, 220), window.innerWidth - 16)}px`;
    panel.style.setProperty('z-index', '2147483000', 'important');
    panel.style.right = 'auto';
    panel.style.maxHeight = `${height}px`;

    if (openUp) {
      picker.classList.add('is-dropup');
      panel.style.top = 'auto';
      panel.style.bottom = `${window.innerHeight - triggerRect.top + gap}px`;
    } else {
      picker.classList.remove('is-dropup');
      panel.style.bottom = 'auto';
      panel.style.top = `${triggerRect.bottom + gap}px`;
    }
  }

  bindPickerScrollClose() {
    if (this._pickerScrollCloseBound) return;
    this._pickerScrollCloseBound = true;
    window.addEventListener(
      'scroll',
      (event) => {
        const target = event.target;
        // Ignore scrolls inside the dropdown list/search — only close on page scroll.
        if (target instanceof Element) {
          if (target.closest('.duo-free-picker__panel, .duo-free-picker__list, .duo-free-picker__search')) {
            return;
          }
          const isPage =
            target === document.documentElement ||
            target === document.body ||
            target === document.scrollingElement;
          if (!isPage) return;
        } else if (target !== document) {
          return;
        }
        if (
          !document.querySelector('.duo-free-picker.is-open, .duo-b-picker.is-open')
        ) {
          return;
        }
        this.closeOpenDuoPickers();
      },
      { passive: true, capture: true }
    );
  }

  cacheElements() {
    this.statusEl = this.querySelector('[data-duo-status]');
    this.rowsRoot = this.querySelector('[data-duo-pairs-root]');
    this.bagWrap = this.querySelector('[data-duo-bag]');
    this.chooserHint = this.querySelector('[data-duo-chooser-hint]');
    this.galleryEl = this.querySelector('[data-duo-gallery]');
    this.aPickerRoot = this.querySelector('[data-duo-a-picker]');
    this.layoutB = this.querySelector('[data-duo-layout-b]');
    this.bColorRoot = this.querySelector('[data-duo-b-color]');
    this.bAddBtn = this.querySelector('[data-duo-b-add]');
    this.bMeta = this.querySelector('[data-duo-b-meta]');
    this.bNailImg = this.querySelector('[data-duo-b-nail]');
    this.bGelImg = this.querySelector('[data-duo-b-gel]');
    this.bNailLabel = this.querySelector('[data-duo-b-nail-label]');
    this.bGelLabel = this.querySelector('[data-duo-b-gel-label]');
    this.bNailPrice = this.querySelector('[data-duo-b-nail-price]');
    this.bGelPrice = this.querySelector('[data-duo-b-gel-price]');
    this.bStage = this.querySelector('[data-duo-b-stage]');
    this.freeWrap = this.querySelector('[data-duo-free]');
    this.freeNote = this.querySelector('[data-duo-free-note]');
    this.freeA = this.querySelector('[data-duo-free-a]');
    this.freeB = this.querySelector('[data-duo-free-b]');
    this.countEl = this.querySelector('[data-duo-count]');
    this.totalEl = this.querySelector('[data-duo-total]');
    this.progressEl = this.querySelector('[data-duo-progress]');
    this.progressFill = this.querySelector('[data-duo-progress-fill]');
    this.atcBtn = this.querySelector('[data-duo-atc]');
    this.errorEl = this.querySelector('[data-duo-error]');
  }

  normalizeCode(value) {
    const raw = String(value == null ? '' : value).trim();
    if (!raw) return '';
    const asNum = Number(raw);
    if (!Number.isNaN(asNum)) return String(asNum);
    return raw.toLowerCase();
  }

  codeKeys(value) {
    const raw = String(value == null ? '' : value).trim();
    if (!raw) return [];
    const keys = new Set([raw, raw.toLowerCase()]);
    const asNum = Number(raw);
    if (!Number.isNaN(asNum)) {
      keys.add(String(asNum));
      if (Number.isInteger(asNum) && asNum >= 0 && asNum < 10000) {
        keys.add(String(asNum).padStart(2, '0'));
        keys.add(String(asNum).padStart(3, '0'));
        keys.add(String(asNum).padStart(4, '0'));
      }
    }
    return Array.from(keys);
  }

  variantMap(variants) {
    const map = new Map();
    variants.forEach((variant) => {
      this.codeKeys(variant.option1 || variant.title).forEach((key) => {
        if (key && !map.has(key)) map.set(key, variant);
      });
    });
    return map;
  }

  findVariant(map, code) {
    if (!map) return null;
    for (const key of this.codeKeys(code)) {
      if (map.has(key)) return map.get(key);
    }
    return null;
  }

  async hydrateProducts() {
    try {
      this.cacheElements();
      const urlA = this.dataset.variantsAUrl;
      const urlB = this.dataset.variantsBUrl;
      if (!urlA || !urlB) throw new Error('Missing variant catalogs');
      if (!this.galleryEl || !this.rowsRoot) throw new Error('Duo builder markup is incomplete');

      const [variantsA, variantsB] = await Promise.all([
        fetch(urlA).then((response) => {
          if (!response.ok) throw new Error('Could not load nail polish shades');
          return response.json();
        }),
        fetch(urlB).then((response) => {
          if (!response.ok) throw new Error('Could not load gel polish shades');
          return response.json();
        })
      ]);

      this.variantsA = Array.isArray(variantsA) ? variantsA : [];
      this.variantsB = Array.isArray(variantsB) ? variantsB : [];

      const mapA = this.variantMap(this.variantsA);
      const mapB = this.variantMap(this.variantsB);

      this.pairs = this.pairs.map((pair) => {
        const variantA = this.findVariant(mapA, pair.codeA);
        const variantB = this.findVariant(mapB, pair.codeB);
        return {
          ...pair,
          variantAId: variantA ? variantA.id : null,
          variantBId: variantB ? variantB.id : null,
          priceA: variantA ? Number(variantA.price || 0) : 0,
          priceB: variantB ? Number(variantB.price || 0) : 0,
          available: Boolean(variantA?.available && variantB?.available)
        };
      });

      this.ready = true;
      this.clearError();
      if (this.statusEl) this.statusEl.hidden = true;
      this.renderGallery();
      if (this.layoutVariant === 'b') {
        this.renderBPicker();
        this.updateBStage();
      } else {
        this.renderAPicker();
      }
      this.sync();
      this.updatePairPriceHint();
    } catch (error) {
      if (this.statusEl) {
        this.statusEl.hidden = false;
        this.statusEl.textContent =
          typeof error?.message === 'string'
            ? error.message
            : 'Could not load product shades.';
      }
      this.showError('Could not load product shades. Refresh and try again.');
      console.error('[product-duo-builder]', error);
    }
  }

  parseJSON(selector) {
    const el = this.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  formatMoney(cents) {
    const amount = (Number(cents) / 100).toFixed(2);
    const format = this.dataset.moneyFormat || '{{amount}}';
    if (format.includes('{{amount_no_decimals}}')) {
      return format.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    if (format.includes('{{amount}}')) {
      return format.replace('{{amount}}', amount);
    }
    return amount;
  }

  updatePairPriceHint() {
    if (!this.chooserHint) return;
    const available = this.availablePairs();
    if (!available.length) return;
    const labelA = this.shortProductLabel(this.dataset.productATitle || 'Nail');
    const labelB = this.shortProductLabel(this.dataset.productBTitle || 'Gel');
    const priceLines = available.map((pair) => ({
      a: Number(pair.priceA || 0),
      b: Number(pair.priceB || 0)
    }));
    const same = priceLines.every((entry) => entry.a === priceLines[0].a && entry.b === priceLines[0].b);
    const base =
      this.rows.length > 0
        ? 'Tap another shade to add another pair.'
        : 'Tap a color to add the matching nail + gel pair.';
    if (same && (priceLines[0].a > 0 || priceLines[0].b > 0)) {
      this.chooserHint.textContent = `${base} ${labelA} ${this.formatMoney(priceLines[0].a)} + ${labelB} ${this.formatMoney(priceLines[0].b)}.`;
    } else {
      this.chooserHint.textContent = base;
    }
  }

  shortProductLabel(title) {
    const raw = String(title || '').trim();
    if (!raw) return 'Shade';
    const lower = raw.toLowerCase();
    if (lower.includes('gel')) return 'Gel';
    if (lower.includes('nail')) return 'Nail';
    const words = raw.split(/\s+/).filter(Boolean);
    return words[words.length - 1] || raw;
  }

  pairPriceLabel(pair) {
    const labelA = this.shortProductLabel(this.dataset.productATitle || 'Nail');
    const labelB = this.shortProductLabel(this.dataset.productBTitle || 'Gel');
    const priceA = Number(pair.priceA || 0);
    const priceB = Number(pair.priceB || 0);
    return `${labelA} ${this.formatMoney(priceA)} + ${labelB} ${this.formatMoney(priceB)}`;
  }

  availablePairs() {
    return this.pairs.filter((pair) => pair.available && pair.variantAId && pair.variantBId);
  }

  usedPairCounts() {
    const counts = new Map();
    this.rows.forEach((row) => {
      if (!row.pairId) return;
      counts.set(row.pairId, (counts.get(row.pairId) || 0) + 1);
    });
    return counts;
  }

  renderGallery() {
    if (!this.galleryEl) return;
    const used = this.usedPairCounts();
    const items = this.availablePairs();

    this.galleryEl.innerHTML = items
      .map((pair) => {
        const count = used.get(pair.id) || 0;
        const priceLabel = this.pairPriceLabel(pair);
        const label = count
          ? `${pair.colorName}, ${priceLabel}, ${count} in bag, add again`
          : `Add ${pair.colorName} pair, ${priceLabel}`;
        const gelSrc = pair.gelImage || '';
        return `
        <button
          type="button"
          class="duo-tile duo-tile--pair${count ? ' is-in-bag' : ''}"
          data-pair-id="${pair.id}"
          aria-label="${label}"
        >
          <span class="duo-tile__pair">
            <span class="duo-tile__media duo-tile__media--nail">
              <img src="${pair.nailImage}" alt="" loading="lazy" decoding="async" />
            </span>
            <span class="duo-tile__connector" aria-hidden="true">
              <span class="duo-tile__plus">+</span>
              <span class="duo-tile__connector-copy">color matched</span>
            </span>
            <span class="duo-tile__media duo-tile__media--gel">
              <img src="${gelSrc}" alt="" loading="lazy" decoding="async" />
            </span>
            ${count ? `<span class="duo-tile__count">${count}</span>` : ''}
          </span>
          <span class="duo-tile__meta">
            <span class="duo-tile__name">${pair.colorName}</span>
            <span class="duo-tile__price">${priceLabel}</span>
          </span>
        </button>`;
      })
      .join('');

    this.galleryEl.querySelectorAll('[data-pair-id]').forEach((button) => {
      button.addEventListener('click', () => this.addPair(button.getAttribute('data-pair-id')));
    });
  }

  renderAPicker() {
    if (!this.aPickerRoot || this.layoutVariant === 'b') return;
    const options = this.availablePairs();
    const used = this.usedPairCounts();

    const picker = document.createElement('div');
    picker.className = 'duo-free-picker duo-a-picker';
    picker.dataset.duoAPicker = 'true';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'duo-free-picker__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = `<span class="duo-free-picker__placeholder">Find a shade</span><span class="duo-free-picker__chevron" aria-hidden="true"></span>`;

    const panel = document.createElement('div');
    panel.className = 'duo-free-picker__panel';
    panel.hidden = true;

    const search = document.createElement('input');
    search.type = 'search';
    search.className = 'duo-free-picker__search';
    search.placeholder = 'Type a color name…';
    search.autocomplete = 'off';
    search.value = this.aPickerQuery || '';

    const list = document.createElement('div');
    list.className = 'duo-free-picker__list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Color shades');

    const placePanel = () => {
      this.placePortaledPanel(picker, panel, trigger, { preferred: 320 });
    };

    const closePanel = () => {
      picker.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      this.unportalPickerPanel(picker, panel);
    };

    const paintOptions = () => {
      const query = String(search.value || '')
        .trim()
        .toLowerCase();
      this.aPickerQuery = search.value || '';
      const filtered = options.filter((pair) => {
        if (!query) return true;
        return (
          pair.colorName.toLowerCase().includes(query) ||
          String(pair.codeA).includes(query) ||
          String(pair.codeB).includes(query)
        );
      });
      list.innerHTML = '';
      if (!filtered.length) {
        const empty = document.createElement('p');
        empty.className = 'duo-free-picker__empty';
        empty.textContent = 'No shades match';
        list.appendChild(empty);
        return;
      }
      filtered.forEach((pair) => {
        const count = used.get(pair.id) || 0;
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'duo-free-picker__option';
        option.setAttribute('role', 'option');
        option.setAttribute(
          'aria-label',
          count ? `Show ${pair.colorName}, ${count} in bag` : `Show ${pair.colorName}`
        );
        option.appendChild(this.duoShadeSwatchEl(pair));
        const name = document.createElement('span');
        name.className = 'duo-free-picker__option-label';
        name.textContent = pair.colorName;
        option.appendChild(name);
        const meta = document.createElement('span');
        meta.className = 'duo-free-picker__option-meta';
        meta.textContent = this.pairPriceLabel(pair);
        if (count) {
          const badge = document.createElement('span');
          badge.className = 'duo-free-picker__option-count';
          badge.textContent = String(count);
          meta.appendChild(badge);
        }
        option.appendChild(meta);
        option.addEventListener('click', () => {
          this.aPickerQuery = '';
          closePanel();
          this.scrollToPair(pair.id);
        });
        list.appendChild(option);
      });
    };

    const openPanel = () => {
      this.closeOpenDuoPickers();
      picker.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      search.value = this.aPickerQuery || '';
      paintOptions();
      placePanel();
      requestAnimationFrame(() => {
        search.focus();
        search.select?.();
      });
    };

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (picker.classList.contains('is-open')) closePanel();
      else openPanel();
    });
    search.addEventListener('input', paintOptions);
    search.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePanel();
        trigger.focus();
      }
      if (event.key === 'Enter') {
        const first = list.querySelector('.duo-free-picker__option');
        if (first) {
          event.preventDefault();
          first.click();
        }
      }
    });

    if (!this._aPickerOutsideBound) {
      this._aPickerOutsideBound = true;
      document.addEventListener('click', (event) => {
        if (event.target.closest('.duo-a-picker, .duo-free-picker__panel')) return;
        if (!this.aPickerRoot?.querySelector('.duo-a-picker.is-open') && !document.querySelector('.duo-a-picker.is-open')) {
          return;
        }
        this.closeOpenDuoPickers();
      });
    }

    panel.appendChild(search);
    panel.appendChild(list);
    picker.appendChild(trigger);
    picker.appendChild(panel);
    this.aPickerRoot.innerHTML = '';
    this.aPickerRoot.appendChild(picker);
  }

  scrollToPair(pairId) {
    if (!this.galleryEl) return;
    const id = String(pairId);
    const tile =
      this.galleryEl.querySelector(`[data-pair-id="${CSS.escape(id)}"]`) ||
      this.galleryEl.querySelector(`[data-pair-id="${id.replace(/"/g, '')}"]`);
    if (!tile) return;

    tile.classList.add('is-flash');
    tile.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (typeof tile.focus === 'function') {
      try {
        tile.focus({ preventScroll: true });
      } catch (error) {
        tile.focus();
      }
    }
    window.setTimeout(() => tile.classList.remove('is-flash'), 1200);
  }

  addPair(pairId) {
    const pair = this.pairs.find((entry) => String(entry.id) === String(pairId));
    if (!pair || !pair.available) return;

    const row = {
      id: `row-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      pairId: pair.id,
      el: null
    };
    row.el = this.renderBagChip(row, pair);
    this.rows.push(row);
    this.rowsRoot.appendChild(row.el);
    this.renderGallery();
    if (this.layoutVariant !== 'b') this.renderAPicker();
    this.sync();
    this.scrollBagToEnd();
  }

  addBSelectedPair() {
    if (!this.bSelectedPairId) return;
    this.addPair(this.bSelectedPairId);
    this.resetBSelection();
  }

  resetBSelection() {
    this.bSelectedPairId = null;
    this.bPickerQuery = '';
    this.renderBPicker();
    this.updateBStage();
  }

  getBSelectedPair() {
    if (!this.bSelectedPairId) return null;
    return this.availablePairs().find((pair) => String(pair.id) === String(this.bSelectedPairId)) || null;
  }

  updateBStage() {
    const pair = this.getBSelectedPair();
    const labelA = this.shortProductLabel(this.dataset.productATitle || 'Nail');
    const labelB = this.shortProductLabel(this.dataset.productBTitle || 'Gel');
    this.bStage?.classList.toggle('is-empty', !pair);

    if (this.bAddBtn) {
      this.bAddBtn.disabled = !pair;
      const baseLabel = this.dataset.bAddLabel || 'Add this pair';
      this.bAddBtn.textContent = pair ? `${baseLabel}: ${pair.colorName}` : baseLabel;
      this.syncBAddButtonStyle(pair);
    }

    if (!pair) {
      if (this.bNailLabel) this.bNailLabel.textContent = 'Nail polish';
      if (this.bGelLabel) this.bGelLabel.textContent = 'Gel polish';
      if (this.bNailPrice) this.bNailPrice.textContent = '';
      if (this.bGelPrice) this.bGelPrice.textContent = '';
      if (this.bNailImg?.dataset.duoPlaceholder) {
        this.bNailImg.src = this.bNailImg.dataset.duoPlaceholder;
        this.bNailImg.alt = this.dataset.productATitle || 'Nail polish';
      }
      if (this.bGelImg?.dataset.duoPlaceholder) {
        this.bGelImg.src = this.bGelImg.dataset.duoPlaceholder;
        this.bGelImg.alt = this.dataset.productBTitle || 'Gel polish';
      }
      if (this.bMeta) {
        this.bMeta.textContent =
          this.rows.length > 0 ? 'Pick another shade to keep building your set.' : 'Select a shade to preview the matching pair.';
      }
      return;
    }

    if (this.bNailImg && pair.nailImage) {
      this.bNailImg.src = pair.nailImage;
      this.bNailImg.alt = `${pair.colorName} nail polish`;
    }
    if (this.bGelImg && pair.gelImage) {
      this.bGelImg.src = pair.gelImage;
      this.bGelImg.alt = `${pair.colorName} gel polish`;
    }
    if (this.bNailLabel) this.bNailLabel.textContent = `${labelA} · ${pair.colorName}`;
    if (this.bGelLabel) this.bGelLabel.textContent = `${labelB} · ${pair.colorName}`;
    if (this.bNailPrice) this.bNailPrice.textContent = this.formatMoney(pair.priceA || 0);
    if (this.bGelPrice) this.bGelPrice.textContent = this.formatMoney(pair.priceB || 0);
    if (this.bMeta) this.bMeta.textContent = this.pairPriceLabel(pair);
  }

  syncBAddButtonStyle(pair) {
    if (!this.bAddBtn) return;
    if (!pair) {
      this.bAddBtn.style.removeProperty('--duo-b-add-bg');
      this.bAddBtn.style.removeProperty('--duo-b-add-fg');
      this.bAddBtn.style.removeProperty('background');
      this.bAddBtn.style.removeProperty('background-color');
      this.bAddBtn.style.removeProperty('color');
      this.bAddBtn.classList.remove('has-shade-color');
      return;
    }

    const bg = this.duoShadeAccent(pair);
    const fg = this.duoContrastText(bg);
    this.bAddBtn.style.setProperty('--duo-b-add-bg', bg);
    this.bAddBtn.style.setProperty('--duo-b-add-fg', fg);
    this.bAddBtn.style.setProperty('background', bg, 'important');
    this.bAddBtn.style.setProperty('background-color', bg, 'important');
    this.bAddBtn.style.setProperty('color', fg, 'important');
    this.bAddBtn.classList.add('has-shade-color');
  }

  duoShadeAccent(pair) {
    const name = String(pair?.colorName || '')
      .trim()
      .toLowerCase();
    const byName = {
      mustard: '#C9A227',
      taupe: '#8B7D6B',
      terracotta: '#C45C3A',
      burgundy: '#6E2B36',
      'olive green': '#556B2F',
      'sage grey': '#8FA08C',
      'sage gray': '#8FA08C',
      caramel: '#C4894A',
      'chestnut brown': '#8B4A32',
      'golden brown': '#A67C2E',
      'khaki green': '#8A9A5B',
      'espresso brown': '#4A3728',
      'moss green': '#5F7355',
      teal: '#2A7A7B',
      'olive grey': '#6B705C',
      'royal purple': '#6B3FA0',
      'jet black': '#1a1a1a'
    };
    if (byName[name]) return byName[name];

    const hints = [
      [/black|jet/, '#1a1a1a'],
      [/white|opaque white|sheer white/, '#f3eee4'],
      [/pink|blush|coral|berry|rose|neon pink|neon coral/, '#c45b7a'],
      [/lilac|lavender|purple|aubergine|plum|indigo|periwinkle/, '#7a5a8c'],
      [/blue|navy|slate|aqua|teal|mint|icy/, '#3d6b8a'],
      [/green|olive|sage|forest|neon green/, '#5a7a4a'],
      [/yellow|lemon|butter|mustard|gold/, '#c9a227'],
      [/orange|sienna|brick|neon orange/, '#c45c3a'],
      [/brown|taupe|beige|nude|caramel|chocolate|cocoa|woodland/, '#8b5a3c'],
      [/gray|grey|silver/, '#8a8a8a']
    ];
    for (const [pattern, hex] of hints) {
      if (pattern.test(name)) return hex;
    }

    const byCode = {
      350: '#C9A227',
      223: '#8B7D6B',
      '020': '#C45C3A',
      '054': '#6E2B36',
      169: '#556B2F',
      212: '#8FA08C',
      353: '#C4894A',
      348: '#8B4A32',
      '030': '#A67C2E',
      197: '#8A9A5B',
      347: '#4A3728',
      161: '#5F7355',
      356: '#2A7A7B',
      216: '#6B705C',
      439: '#6B3FA0'
    };
    const code = String(pair?.codeB || '').trim();
    if (byCode[code] || byCode[this.normalizeCode(code)]) {
      return byCode[code] || byCode[this.normalizeCode(code)];
    }

    // Deterministic accent for the expanded shade guide.
    let hash = 0;
    const seed = name || code || 'shade';
    for (let i = 0; i < seed.length; i += 1) {
      hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
    }
    const h = hash % 360;
    const s = 40 + (hash % 18);
    const l = 38 + ((hash >>> 8) % 14);
    return this.hslToHex(h, s, l);
  }

  hslToHex(h, s, l) {
    const sat = s / 100;
    const light = l / 100;
    const k = (n) => (n + h / 30) % 12;
    const a = sat * Math.min(light, 1 - light);
    const f = (n) => light - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    const toHex = (value) =>
      Math.round(255 * value)
        .toString(16)
        .padStart(2, '0');
    return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
  }

  duoContrastText(hex) {
    const raw = String(hex || '').replace('#', '');
    if (raw.length !== 3 && raw.length !== 6) return '#ffffff';
    const full =
      raw.length === 3
        ? raw
            .split('')
            .map((ch) => ch + ch)
            .join('')
        : raw;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    if ([r, g, b].some((n) => Number.isNaN(n))) return '#ffffff';
    // Relative luminance — light shades get dark ink for readability.
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return luminance > 0.58 ? '#1a1210' : '#ffffff';
  }

  renderBPicker() {
    if (!this.bColorRoot) return;
    const options = this.availablePairs();
    const selected = this.getBSelectedPair();
    const q = String(this.bPickerQuery || '')
      .trim()
      .toLowerCase();

    const picker = document.createElement('div');
    picker.className = 'duo-free-picker duo-b-picker';
    picker.dataset.duoBPicker = 'true';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'duo-free-picker__trigger';
    trigger.setAttribute('aria-expanded', 'false');
    if (selected) {
      trigger.appendChild(this.duoShadeSwatchEl(selected));
      const value = document.createElement('span');
      value.className = 'duo-free-picker__value';
      value.textContent = selected.colorName;
      trigger.appendChild(value);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'duo-free-picker__placeholder';
      placeholder.textContent = this.dataset.bPickerLabel || 'Choose a shade';
      trigger.appendChild(placeholder);
    }
    const chevron = document.createElement('span');
    chevron.className = 'duo-free-picker__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    trigger.appendChild(chevron);

    const panel = document.createElement('div');
    panel.className = 'duo-free-picker__panel';
    panel.hidden = true;

    const search = document.createElement('input');
    search.type = 'search';
    search.className = 'duo-free-picker__search';
    search.placeholder = 'Search colors';
    search.autocomplete = 'off';
    search.value = this.bPickerQuery || '';

    const list = document.createElement('div');
    list.className = 'duo-free-picker__list';
    list.setAttribute('role', 'listbox');

    const paintOptions = () => {
      const query = String(search.value || '')
        .trim()
        .toLowerCase();
      this.bPickerQuery = search.value || '';
      const filtered = options.filter((pair) => {
        if (!query) return true;
        return (
          pair.colorName.toLowerCase().includes(query) ||
          String(pair.codeA).includes(query) ||
          String(pair.codeB).includes(query)
        );
      });
      list.innerHTML = '';
      if (!filtered.length) {
        const empty = document.createElement('p');
        empty.className = 'duo-free-picker__empty';
        empty.textContent = 'No shades match';
        list.appendChild(empty);
        return;
      }
      filtered.forEach((pair) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'duo-free-picker__option';
        if (String(pair.id) === String(this.bSelectedPairId)) option.classList.add('is-selected');
        option.setAttribute('role', 'option');
        option.appendChild(this.duoShadeSwatchEl(pair));
        const name = document.createElement('span');
        name.className = 'duo-free-picker__option-label';
        name.textContent = pair.colorName;
        option.appendChild(name);
        option.addEventListener('click', () => {
          this.bSelectedPairId = pair.id;
          this.bPickerQuery = '';
          closePanel();
          this.renderBPicker();
          this.updateBStage();
        });
        list.appendChild(option);
      });
    };

    const placePanel = () => {
      this.placePortaledPanel(picker, panel, trigger, { preferred: 280 });
    };

    const closePanel = () => {
      picker.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      this.unportalPickerPanel(picker, panel);
    };

    const openPanel = () => {
      this.closeOpenDuoPickers();
      picker.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      paintOptions();
      placePanel();
    };

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      if (picker.classList.contains('is-open')) closePanel();
      else openPanel();
    });
    search.addEventListener('input', paintOptions);

    if (!this._bPickerOutsideBound) {
      this._bPickerOutsideBound = true;
      document.addEventListener('click', (event) => {
        if (event.target.closest('.duo-b-picker, .duo-free-picker__panel')) return;
        this.closeOpenDuoPickers();
      });
    }

    panel.appendChild(search);
    panel.appendChild(list);
    picker.appendChild(trigger);
    picker.appendChild(panel);
    this.bColorRoot.innerHTML = '';
    this.bColorRoot.appendChild(picker);
    paintOptions();
  }

  removeRow(rowId) {
    const index = this.rows.findIndex((row) => row.id === rowId);
    if (index < 0) return;
    const [row] = this.rows.splice(index, 1);
    row.el?.remove();
    this.renderGallery();
    if (this.layoutVariant !== 'b') this.renderAPicker();
    this.sync();
  }

  scrollBagToEnd() {
    if (!this.rowsRoot) return;
    requestAnimationFrame(() => {
      this.rowsRoot.scrollTo({ left: this.rowsRoot.scrollWidth, behavior: 'smooth' });
    });
  }

  renderBagChip(row, pair) {
    const el = document.createElement('article');
    el.className = 'duo-bag-chip';
    el.dataset.rowId = row.id;
    el.innerHTML = `
      <span class="duo-bag-chip__media">
        <img src="${pair.nailImage}" alt="" />
      </span>
      <span class="duo-bag-chip__name">${pair.colorName}</span>
      <button type="button" class="duo-bag-chip__remove" data-row-remove aria-label="Remove ${pair.colorName}">×</button>
    `;
    el.querySelector('[data-row-remove]')?.addEventListener('click', (event) => {
      event.stopPropagation();
      this.removeRow(row.id);
    });
    return el;
  }

  selectedPairs() {
    return this.rows
      .map((row) => this.pairs.find((pair) => pair.id === row.pairId))
      .filter(Boolean);
  }

  bestOffer(offers, qty) {
    const list = Array.isArray(offers) ? offers : [];
    let best = null;
    list.forEach((offer) => {
      const buy = Number(offer.buy || 0);
      const get = Number(offer.get || 0);
      if (buy <= 0 || get <= 0) return;
      if (qty >= buy && (!best || buy > Number(best.buy))) {
        best = offer;
      }
    });
    return best;
  }

  nextOfferHint(offers, qty) {
    const list = Array.isArray(offers) ? [...offers] : [];
    list.sort((a, b) => Number(a.buy) - Number(b.buy));
    for (const offer of list) {
      const buy = Number(offer.buy || 0);
      const get = Number(offer.get || 0);
      if (buy > qty) {
        return { offer, remaining: buy - qty, get };
      }
    }
    return null;
  }

  freeGetQty() {
    const count = this.selectedPairs().length;
    const offerA = this.bestOffer(this.offers.a, count);
    const offerB = this.bestOffer(this.offers.b, count);
    return {
      count,
      getA: offerA ? Number(offerA.get) : 0,
      getB: offerB ? Number(offerB.get) : 0,
      offerA,
      offerB
    };
  }

  renderFreeSlots() {
    const { count, getA, getB, offerA, offerB } = this.freeGetQty();
    const unlocked = getA > 0 || getB > 0;
    if (!this.freeWrap) return { getA, getB };

    this.freeWrap.hidden = !unlocked;
    this.freeWrap.setAttribute('aria-hidden', unlocked ? 'false' : 'true');
    if (!unlocked) {
      if (this.freeA) this.freeA.innerHTML = '';
      if (this.freeB) this.freeB.innerHTML = '';
      return { getA: 0, getB: 0 };
    }

    const labelA = offerA?.shortLabel || offerA?.title || 'Offer';
    const labelB = offerB?.shortLabel || offerB?.title || 'Offer';
    if (this.freeNote) {
      this.freeNote.textContent =
        'Select free shades by name from this Color Duos palette. Applied free at checkout.';
    }

    this.paintFreeColumn(this.freeA, getA, 'a', this.dataset.productATitle || 'Nail');
    this.paintFreeColumn(this.freeB, getB, 'b', this.dataset.productBTitle || 'Gel');
    return { getA, getB };
  }

  freeShadeOptions(side) {
    const key = side === 'a' ? 'variantAId' : 'variantBId';
    const byId = new Map();
    this.availablePairs().forEach((pair) => {
      const id = pair[key];
      if (!id || byId.has(id)) return;
      byId.set(id, {
        id,
        label: pair.colorName,
        colorName: pair.colorName,
        codeB: pair.codeB,
        image: pair.nailImage
      });
    });
    return Array.from(byId.values()).sort((a, b) => a.label.localeCompare(b.label));
  }

  duoShadeSwatchEl(pairLike) {
    const swatch = document.createElement('span');
    swatch.className = 'duo-free-picker__swatch';
    swatch.setAttribute('aria-hidden', 'true');
    swatch.style.backgroundColor = this.duoShadeAccent(pairLike);
    return swatch;
  }

  paintFreeColumn(root, getQty, side, title) {
    if (!root) return;
    const existing = Array.from(root.querySelectorAll('[data-free-slot]')).map(
      (slot) => slot.dataset.freeValue || ''
    );
    root.innerHTML = '';
    if (getQty <= 0) return;

    const options = this.freeShadeOptions(side);
    if (!this._freePickerOutsideBound) {
      this._freePickerOutsideBound = true;
      document.addEventListener('click', (event) => {
        if (event.target.closest('.duo-free-picker, .duo-b-picker, .duo-free-picker__panel')) return;
        this.closeOpenDuoPickers();
      });
    }

    for (let i = 0; i < getQty; i += 1) {
      const wrap = document.createElement('div');
      wrap.className = 'duo-free__slot';
      wrap.dataset.freeSlot = '';
      wrap.dataset.freeSide = side;
      wrap.dataset.freeValue = existing[i] || '';

      const label = document.createElement('label');
      label.className = 'duo-free__slot-label';
      const inputId = `duo-free-${side}-${i}-${Math.random().toString(16).slice(2, 8)}`;
      label.setAttribute('for', inputId);
      label.textContent = `Free ${title}${getQty > 1 ? ` ${i + 1}` : ''}`;

      const picker = document.createElement('div');
      picker.className = 'duo-free-picker';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'duo-free-picker__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      const setTriggerLabel = () => {
        const current = options.find((entry) => String(entry.id) === String(wrap.dataset.freeValue));
        trigger.replaceChildren();
        if (current) {
          trigger.appendChild(this.duoShadeSwatchEl(current));
          const value = document.createElement('span');
          value.className = 'duo-free-picker__value';
          value.textContent = current.label;
          trigger.appendChild(value);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'duo-free-picker__placeholder';
          placeholder.textContent = 'Search a color';
          trigger.appendChild(placeholder);
        }
        const chevron = document.createElement('span');
        chevron.className = 'duo-free-picker__chevron';
        chevron.setAttribute('aria-hidden', 'true');
        trigger.appendChild(chevron);
      };
      setTriggerLabel();

      const panel = document.createElement('div');
      panel.className = 'duo-free-picker__panel';
      panel.hidden = true;

      const search = document.createElement('input');
      search.type = 'search';
      search.id = inputId;
      search.className = 'duo-free-picker__search';
      search.placeholder = 'Search colors';
      search.autocomplete = 'off';

      const list = document.createElement('div');
      list.className = 'duo-free-picker__list';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', label.textContent);

      const clearPanelPlacement = () => {
        this.unportalPickerPanel(picker, panel);
        picker.classList.remove('is-dropup');
      };

      const placePanel = () => {
        this.placePortaledPanel(picker, panel, trigger, { preferred: 280 });
      };

      const closePanel = () => {
        panel.hidden = true;
        picker.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        clearPanelPlacement();
      };

      const renderOptions = (query = '') => {
        const q = String(query || '')
          .trim()
          .toLowerCase();
        const filtered = options.filter((entry) => !q || entry.label.toLowerCase().includes(q));
        list.innerHTML = '';
        if (!filtered.length) {
          const empty = document.createElement('p');
          empty.className = 'duo-free-picker__empty';
          empty.textContent = 'No matching colors';
          list.appendChild(empty);
          return;
        }
        filtered.forEach((entry) => {
          const option = document.createElement('button');
          option.type = 'button';
          option.className = 'duo-free-picker__option';
          option.setAttribute('role', 'option');
          option.dataset.variantId = String(entry.id);
          const on = String(wrap.dataset.freeValue) === String(entry.id);
          option.classList.toggle('is-selected', on);
          option.setAttribute('aria-selected', on ? 'true' : 'false');
          option.appendChild(this.duoShadeSwatchEl(entry));
          const name = document.createElement('span');
          name.className = 'duo-free-picker__option-label';
          name.textContent = entry.label;
          option.appendChild(name);
          option.addEventListener('click', () => {
            wrap.dataset.freeValue = String(entry.id);
            setTriggerLabel();
            closePanel();
            this.sync({ skipFreePaint: true });
          });
          list.appendChild(option);
        });
      };

      const openPanel = () => {
        this.closeOpenDuoPickers();
        panel.hidden = false;
        picker.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        search.value = '';
        renderOptions('');
        placePanel();
      };

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        if (panel.hidden) openPanel();
        else closePanel();
      });

      search.addEventListener('input', () => renderOptions(search.value));
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closePanel();
          trigger.focus();
        }
      });

      panel.appendChild(search);
      panel.appendChild(list);
      picker.appendChild(trigger);
      picker.appendChild(panel);
      wrap.appendChild(label);
      wrap.appendChild(picker);
      root.appendChild(wrap);
    }
  }

  getFreeVariantIds() {
    const ids = [];
    this.querySelectorAll('[data-free-slot]').forEach((slot) => {
      const value = Number(slot.dataset.freeValue || 0);
      if (value) ids.push(value);
    });
    return ids;
  }

  freeSlotsComplete(getA, getB) {
    const needed = getA + getB;
    if (needed === 0) return true;
    return this.getFreeVariantIds().length === needed;
  }

  sync(options = {}) {
    const selected = this.selectedPairs();
    const count = selected.length;
    let total = 0;
    selected.forEach((pair) => {
      total += Number(pair.priceA || 0) + Number(pair.priceB || 0);
    });

    if (this.bagWrap) this.bagWrap.hidden = count === 0;
    this.updatePairPriceHint();

    if (this.countEl) {
      this.countEl.textContent = `${count} pair${count === 1 ? '' : 's'}`;
    }
    if (this.totalEl) this.totalEl.textContent = this.formatMoney(total);

    let getA = 0;
    let getB = 0;
    if (!options.skipFreePaint) {
      ({ getA, getB } = this.renderFreeSlots());
    } else {
      ({ getA, getB } = this.freeGetQty());
    }

    if (this.progressEl) {
      const hint = this.nextOfferHint(this.offers.a, count) || this.nextOfferHint(this.offers.b, count);
      const targetBuy = hint
        ? Number(hint.offer.buy)
        : Math.max(
            Number(this.bestOffer(this.offers.a, count)?.buy || 0),
            Number(this.bestOffer(this.offers.b, count)?.buy || 0),
            6
          );
      const pct = Math.min(100, Math.round((count / Math.max(targetBuy, 1)) * 100));
      if (this.progressFill) this.progressFill.style.width = `${pct}%`;

      if (getA > 0 || getB > 0) {
        this.progressEl.textContent = `Offer unlocked · choose ${getA} free nail + ${getB} free gel`;
      } else if (hint) {
        this.progressEl.textContent = `${hint.remaining} more pair${hint.remaining === 1 ? '' : 's'} for ${hint.get} free nail + ${hint.get} free gel`;
      } else {
        this.progressEl.textContent = '';
      }
    }

    const freeOk = this.freeSlotsComplete(getA, getB);
    this.updateAtcState(count, freeOk);
  }

  updateAtcState(count, freeOk) {
    if (!this.atcBtn) return;
    const text = this.atcBtn.querySelector('.duo-atc__text');
    const atcLabel = this.dataset.atcLabel || 'Add pairs to cart';
    const chooseLabel = 'Choose free pairs';

    if (count <= 0) {
      this.atcBtn.disabled = true;
      this.atcBtn.classList.remove('is-choose-free');
      this.atcBtn.dataset.duoAction = 'disabled';
      if (text) text.textContent = atcLabel;
      return;
    }

    if (!freeOk) {
      this.atcBtn.disabled = false;
      this.atcBtn.classList.add('is-choose-free');
      this.atcBtn.dataset.duoAction = 'choose-free';
      if (text) text.textContent = chooseLabel;
      return;
    }

    this.atcBtn.disabled = false;
    this.atcBtn.classList.remove('is-choose-free');
    this.atcBtn.dataset.duoAction = 'add';
    if (text) text.textContent = atcLabel;
  }

  handleAtcClick() {
    if (this.atcBtn?.dataset.loading === 'true') return;
    if (this.atcBtn?.dataset.duoAction === 'choose-free') {
      this.scrollToFreeSection();
      return;
    }
    this.addToCart();
  }

  scrollToFreeSection() {
    const target = this.freeWrap;
    if (!target || target.hidden) return;

    const headerOffset = this.getStickyHeaderOffset();
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    target.classList.add('is-pulse');
    window.setTimeout(() => target.classList.remove('is-pulse'), 1200);
    const firstTrigger = target.querySelector('.duo-free-picker__trigger');
    window.setTimeout(() => firstTrigger?.focus(), 450);
  }

  getStickyHeaderOffset() {
    const rootStyles = getComputedStyle(document.documentElement);
    const cssHeader = Number.parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
    const sticky =
      document.querySelector('.sticky-header .header_wrapper') ||
      document.querySelector('sticky-header') ||
      document.querySelector('#shopify-section-header') ||
      document.querySelector('header');
    const measured = sticky?.getBoundingClientRect?.().height || 0;
    return Math.max(cssHeader, measured, 0);
  }

  setLoading(isLoading) {
    const text = this.atcBtn?.querySelector('.duo-atc__text');
    const loader = this.atcBtn?.querySelector('.loader');
    if (text) text.style.visibility = isLoading ? 'hidden' : 'visible';
    loader?.classList.toggle('hidden', !isLoading);
    if (this.atcBtn) this.atcBtn.dataset.loading = isLoading ? 'true' : 'false';
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  }

  clearError() {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.hidden = true;
  }

  buildItems() {
    const qtyMap = new Map();
    const bump = (id) => {
      const key = Number(id);
      if (!key) return;
      qtyMap.set(key, (qtyMap.get(key) || 0) + 1);
    };

    this.selectedPairs().forEach((pair) => {
      bump(pair.variantAId);
      bump(pair.variantBId);
    });
    this.getFreeVariantIds().forEach((id) => bump(id));

    return Array.from(qtyMap.entries()).map(([id, quantity]) => ({ id, quantity }));
  }

  async refreshCartSections() {
    const sections = await fetch(
      `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
    ).then((response) => response.json());

    document.dispatchEvent(
      new CustomEvent('cart-update', {
        detail: { sections },
        bubbles: true
      })
    );
  }

  openCartDrawer() {
    const openBtn = document.querySelector('.cart_sidebar_open_btn');
    if (openBtn) {
      openBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  }

  async addToCart() {
    const items = this.buildItems();
    if (!items.length) {
      this.showError('Add at least one color pair.');
      return;
    }

    this.clearError();
    this.setLoading(true);
    if (this.atcBtn) this.atcBtn.disabled = true;

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok) throw data;

      await this.refreshCartSections();
      if (document.querySelector('cart-contents')) {
        this.openCartDrawer();
      } else {
        window.location.href = `${Shopify.routes.root}cart`;
      }
    } catch (error) {
      const message =
        typeof error?.description === 'string'
          ? error.description
          : typeof error?.message === 'string'
            ? error.message
            : 'Could not add pairs. Please try again.';
      this.showError(message);
    } finally {
      this.setLoading(false);
      this.sync({ skipFreePaint: true });
    }
  }
}

customElements.define('product-duo-builder', ProductDuoBuilder);

class BundleDiscountPicker extends HTMLElement {
  constructor() {
    super();
    this.addBundle = this.addBundle.bind(this);
  }

  connectedCallback() {
    this.mainProduct = document.querySelector('main-product-section');
    this.cart = document.querySelector('cart-contents');
    this.offers = Array.from(this.querySelectorAll('[data-bundle-offer]'));

    this.offers.forEach((offer) => {
      offer.querySelector('[data-bundle-add]')?.addEventListener('click', this.addBundle);
    });
  }

  disconnectedCallback() {
    this.offers.forEach((offer) => {
      offer.querySelector('[data-bundle-add]')?.removeEventListener('click', this.addBundle);
    });
  }

  getCurrentVariantId() {
    const form = this.mainProduct?.querySelector('product-form form');
    return form?.querySelector('input[name="id"]')?.value;
  }

  buildItems(offer) {
    const buyQty = Number(offer.dataset.buyQty || 0);
    const getQty = Number(offer.dataset.getQty || 0);
    const useSelectedBuy = offer.dataset.useSelectedBuy === 'true';
    const useSelectedGet = offer.dataset.useSelectedGet === 'true';
    const selectedVariantId = this.getCurrentVariantId();

    let buyVariantId = useSelectedBuy ? selectedVariantId : offer.dataset.buyVariantId;
    let getVariantId = useSelectedGet ? selectedVariantId : offer.dataset.getVariantId;

    if (!buyVariantId || !getVariantId || !buyQty || !getQty) {
      return null;
    }

    const itemsMap = new Map();
    const addItem = (id, quantity) => {
      const numericId = Number(id);
      itemsMap.set(numericId, (itemsMap.get(numericId) || 0) + quantity);
    };

    addItem(buyVariantId, buyQty);
    addItem(getVariantId, getQty);

    return Array.from(itemsMap.entries()).map(([id, quantity]) => ({ id, quantity }));
  }

  async refreshCartSections() {
    const sections = await fetch(
      `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
    ).then((response) => response.json());

    document.dispatchEvent(
      new CustomEvent('cart-update', {
        detail: { sections },
        bubbles: true
      })
    );

    return sections;
  }

  async applyDiscountCode(code) {
    if (!code) return;

    await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        discount: code,
        sections: 'cart-drawer,cart,cart-bubble'
      })
    });
  }

  openCartDrawer() {
    const openBtn = document.querySelector('.cart_sidebar_open_btn');
    if (openBtn) {
      openBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  }

  setButtonLoading(button, isLoading) {
    const text = button.querySelector('.bundle_offer_button_text');
    const loader = button.querySelector('.loader');

    button.disabled = isLoading;
    if (text) text.style.visibility = isLoading ? 'hidden' : 'visible';
    loader?.classList.toggle('hidden', !isLoading);
  }

  showOfferError(offer, message) {
    const error = offer.querySelector('.bundle_offer_error');
    if (!error) return;

    error.textContent = message;
    error.classList.remove('hidden');
  }

  clearOfferError(offer) {
    const error = offer.querySelector('.bundle_offer_error');
    if (!error) return;

    error.textContent = '';
    error.classList.add('hidden');
  }

  async addBundle(event) {
    const button = event.currentTarget;
    const offer = button.closest('[data-bundle-offer]');
    if (!offer) return;

    const items = this.buildItems(offer);
    if (!items) {
      this.showOfferError(offer, 'Unable to build this bundle.');
      return;
    }

    this.clearOfferError(offer);
    this.setButtonLoading(button, true);

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();

      if (!response.ok) {
        throw data;
      }

      await this.applyDiscountCode(offer.dataset.discountCode);
      await this.refreshCartSections();

      if (this.cart) {
        this.openCartDrawer();
      } else {
        window.location.href = `${Shopify.routes.root}cart`;
      }
    } catch (error) {
      const message =
        typeof error?.description === 'string'
          ? error.description
          : typeof error?.message === 'string'
            ? error.message
            : 'Could not add this bundle. Please try again.';

      this.showOfferError(offer, message);
    } finally {
      this.setButtonLoading(button, false);
    }
  }
}

customElements.define('bundle-discount-picker', BundleDiscountPicker);

class PackOfferPicker extends HTMLElement {
  connectedCallback() {
    this.mainProduct = document.querySelector('main-product-section');
    this.errorEl = this.querySelector('[data-pack-error]');
    this.cards = Array.from(this.querySelectorAll('[data-pack-offer]'));

    this.cards.forEach((card) => {
      card.querySelector('[data-pack-select]')?.addEventListener('click', () => this.selectCard(card));
      card.querySelector('[data-pack-add]')?.addEventListener('click', (event) => this.addPack(event, card));
    });
  }

  getVariantInput() {
    const form = this.mainProduct?.querySelector('product-form form') || document.querySelector('product-form form');
    return form?.querySelector('input[name="id"]');
  }

  selectCard(card) {
    const variantId = card.dataset.variantId;
    if (!variantId) return;

    this.cards.forEach((entry) => {
      const on = entry === card;
      entry.classList.toggle('is-selected', on);
      entry.querySelector('[data-pack-select]')?.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    const input = this.getVariantInput();
    if (input) {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const optionInput = this.mainProduct?.querySelector(
      `input[type="radio"][value="${CSS.escape(String(variantId))}"], [data-variant-id="${CSS.escape(String(variantId))}"]`
    );
    if (optionInput && typeof optionInput.click === 'function' && optionInput !== document.activeElement) {
      // Prefer native variant picker radios when present.
      const radio = this.mainProduct?.querySelector(
        `.main_product_option_values_wrap input[type="radio"][value="${CSS.escape(card.querySelector('.pack_offer_title')?.textContent?.trim() || '')}"]`
      );
      radio?.click();
    }

    // Fallback: publish a lightweight variant hint for themes listening to it.
    document.dispatchEvent(
      new CustomEvent('pack-offer-select', {
        detail: { variantId: Number(variantId) },
        bubbles: true
      })
    );
  }

  setButtonLoading(button, isLoading) {
    const text = button.querySelector('.pack_offer_button_text');
    const loader = button.querySelector('.loader');
    button.disabled = isLoading;
    if (text) text.style.visibility = isLoading ? 'hidden' : 'visible';
    loader?.classList.toggle('hidden', !isLoading);
  }

  showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.classList.remove('hidden');
  }

  clearError() {
    if (!this.errorEl) return;
    this.errorEl.textContent = '';
    this.errorEl.classList.add('hidden');
  }

  openCartDrawer() {
    const openBtn = document.querySelector('.cart_sidebar_open_btn');
    if (openBtn) {
      openBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  }

  async addPack(event, card) {
    const button = event.currentTarget;
    const variantId = Number(card.dataset.variantId || 0);
    if (!variantId) return;

    this.clearError();
    this.selectCard(card);
    this.setButtonLoading(button, true);

    try {
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer,cart,cart-bubble'
        })
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.description || data?.message || 'Could not add this pack.');
      }

      if (data.sections) {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { sections: data.sections },
            bubbles: true
          })
        );
      } else {
        const sections = await fetch(`${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`).then((r) =>
          r.json()
        );
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { sections },
            bubbles: true
          })
        );
      }
      this.openCartDrawer();
    } catch (error) {
      this.showError(
        typeof error?.message === 'string' ? error.message : 'Could not add this pack. Please try again.'
      );
    } finally {
      this.setButtonLoading(button, false);
    }
  }
}

customElements.define('pack-offer-picker', PackOfferPicker);

class ProductQuoteRequest extends HTMLElement {
  constructor() {
    super();
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    this.syncVariant = this.syncVariant.bind(this);
  }

  connectedCallback() {
    if (this.dataset.openMode === 'page') return;

    this.modal = this.querySelector('.product_quote_modal');
    this.openButton = this.querySelector('[data-quote-open]');
    this.variants = this.readVariants();

    this.openButton?.addEventListener('click', () => this.openModal());
    this.querySelectorAll('[data-quote-close]').forEach((element) => {
      element.addEventListener('click', () => this.closeModal());
    });

    document.querySelector('main-product-section')?.addEventListener('variant-change', this.syncVariant);
    this.syncVariant();

    if (this.querySelector('.product_quote_success')) {
      this.openModal();
    }
  }

  disconnectedCallback() {
    document.querySelector('main-product-section')?.removeEventListener('variant-change', this.syncVariant);
    document.removeEventListener('keydown', this.handleDocumentKeydown);
    document.body.classList.remove('product-quote-open');
  }

  readVariants() {
    const json = this.querySelector('[data-product-variants]')?.textContent;
    if (!json) return [];
    try {
      return JSON.parse(json);
    } catch {
      return [];
    }
  }

  getSelectedVariantId() {
    const form = document.querySelector('main-product-section product-form form');
    return form?.querySelector('input[name="id"]')?.value;
  }

  syncVariant() {
    const variantId = this.getSelectedVariantId();
    if (!variantId) return;

    const variant = this.variants.find((entry) => String(entry.id) === String(variantId));
    if (!variant) return;

    const sectionId = this.dataset.sectionId;
    const variantInput = this.querySelector(`#quote-variant-${sectionId}`);
    const variantIdInput = this.querySelector(`#quote-variant-id-${sectionId}`);
    const skuInput = this.querySelector(`#quote-sku-${sectionId}`);
    const variantLabel = this.querySelector(`#quote-variant-label-${sectionId}`);

    if (variantInput) variantInput.value = variant.title || '';
    if (variantIdInput) variantIdInput.value = variant.id || '';
    if (skuInput) skuInput.value = variant.sku || '';
    if (variantLabel) variantLabel.textContent = variant.title || '';
  }

  openModal() {
    if (!this.modal) return;

    this.modal.hidden = false;
    this.openButton?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('product-quote-open');
    document.addEventListener('keydown', this.handleDocumentKeydown);

    if (typeof lenis !== 'undefined') {
      lenis.stop();
    }

    const focusTarget = this.modal.querySelector('.product_quote_success, input, textarea, button');
    focusTarget?.focus();
  }

  closeModal() {
    if (!this.modal) return;

    this.modal.hidden = true;
    this.openButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('product-quote-open');
    document.removeEventListener('keydown', this.handleDocumentKeydown);

    if (typeof lenis !== 'undefined') {
      lenis.start();
    }

    this.openButton?.focus();
  }

  handleDocumentKeydown(event) {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  }
}

customElements.define('product-quote-request', ProductQuoteRequest);


// ================== Size chart ========== //

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('.size_chart_popup_main');
  const closeBtn = document.querySelector('.size_chart_popup_close');

  // Open popup
  document.addEventListener('click', (e) => {
    if (e.target.closest('.size_chart_main')) {
      popup.classList.add('active');
      document.body.classList.add('size-chart-active');

      if (typeof lenis !== 'undefined') {
        lenis.stop();
      }
    }
  });

  // Close on outside click
  if (popup) {
    popup.addEventListener('click', (e) => {
      if (!e.target.closest('.size_chart_popup_inner')) {
        closePopup();
      }
    });
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  function closePopup() {
    popup.classList.remove('active');
    document.body.classList.remove('size-chart-active');

    if (typeof lenis !== 'undefined') {
      lenis.start();
    }
  }
});
/* ======================================================================
   MAIN PRODUCT PAGE Component end
   ====================================================================== */

/* ======================================================================
   Cart page and cart drawer PAGE Component 
   ====================================================================== */

  //  ================= Side cart drawer open and close ===================

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".cart_sidebar_open_btn");
  const cartSidebar = document.querySelector(".cart_sidebar_wrapper");
  if (!cartSidebar) return;
  const html = document.documentElement;
  const body = document.body;

  const focusableSelectors = `
    a[href],
    button:not([disabled]),
    textarea,
    input:not([disabled]),
    select,
    [tabindex]:not([tabindex="-1"])
  `;

  let firstFocusableEl = null;
  let lastFocusableEl = null;
  let lastFocusedElement = null;

  function setFocusableElements() {
    const focusables = cartSidebar.querySelectorAll(focusableSelectors);
    firstFocusableEl = focusables[0];
    lastFocusableEl = focusables[focusables.length - 1];
  }

  function openCart(e) {
    if (e) e.preventDefault();

    lastFocusedElement = document.activeElement;

    body.classList.add("cart-sidebar-open");
    html.classList.add("lenis-stopped");

    cartSidebar.classList.add("cart-sidebar-active");
    cartSidebar.removeAttribute("inert");
    cartSidebar.setAttribute("aria-hidden", "false");

    setFocusableElements();
    firstFocusableEl?.focus();
  }

  function closeCart(e) {
    if (e) e.preventDefault();

    body.classList.remove("cart-sidebar-open");
    html.classList.remove("lenis-stopped");

    cartSidebar.classList.remove("cart-sidebar-active");
    cartSidebar.setAttribute("inert", "");
    cartSidebar.setAttribute("aria-hidden", "true");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  /* ==========================
     Focus Trap (TAB Handling)
     ========================== */
  document.addEventListener("keydown", function (e) {
    if (!cartSidebar.classList.contains("cart-sidebar-active")) return;

    if (e.key === "Escape") {
      closeCart();
      return;
    }

    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  });

  /* ==========================
     Close via button (delegated — header HTML is replaced on cart updates)
     or backdrop click
     ========================== */
  cartSidebar.addEventListener("click", function (e) {
    if (e.target === cartSidebar || e.target.closest(".drawer_close_btn-cart")) {
      closeCart(e);
    }
  });

  openBtn?.addEventListener("click", openCart);

  // Expose for other scripts that open the drawer programmatically
  window.__magnoluxOpenCartDrawer = openCart;
  window.__magnoluxCloseCartDrawer = closeCart;
});



//  ================= Side cart drawer (CART QUANTITY PICKER) =================== //
class ItemQuantity extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.input = this.querySelector('input[type="text"]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.value = Number(this.input.value); 
    this.step = Number(this.input.getAttribute('step'));
    this.min = this.input.dataset.min;
    this.max = this.input.dataset.max;
    this.line = this.dataset.line;
  }

  connectedCallback() {
    this.minusBtn.addEventListener('click', this.handleChange.bind(this));
    this.plusBtn.addEventListener('click', this.handleChange.bind(this));
    const debouncedInputandler = this._debounce((e) => this.handleInput(e), 1000)
    this.input.addEventListener('input', debouncedInputandler);
  }

  handleChange(e) {
    if(e.currentTarget.hasAttribute('data-plus')) {
      this.value = this.value + this.step;
      this.input.value = this.value;
    } else {
      this.value = this.value - this.step;
      this.input.value = this.value;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }
    
    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart-quantity-change', {
        detail: {
          value: this.value,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    )    
  }

  handleInput(e) {
    this.value = Number(this.input.value);
    if(this.value == 0) {
      this.value = 1;
      this.input.value = 1;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }

    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    this.dispatchEvent(
      new CustomEvent('cart-quantity-change', {
        detail: {
          value: this.value,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    ) 

  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('item-quantity', ItemQuantity);


//  ================= Side cart drawer (CART REMOVE) =================== //
class ItemRemove extends HTMLElement {
  constructor() {
    super();
    this.line = this.dataset.line;
    this.anchor = this.querySelector('a.item_remove_btn');
  }

  connectedCallback() {
    this.anchor.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent('cart-item-remove', {
        detail: {
          value: 0,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('item-remove', ItemRemove);



// ========== CART NOTE ==========
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.textarea = this.querySelector('textarea');
    this.debounceTimer = null;
  }

  connectedCallback() {
    if (this.textarea && this.textarea.value.trim() !== '') {
      this.details.setAttribute('open', '');
    }

    this.textarea.addEventListener('input', () => {
      this.details.setAttribute('open', '');

      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.updateCartNote(this.textarea.value.trim());
      }, 500); 
    });
  }

  updateCartNote(value) {
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        note: value
      })
    })
    .then(res => res.json())
    .then(() => {
      console.log('Cart note updated');
    })
    .catch(err => {
      console.error('Cart note update failed', err);
    });
  }
}

customElements.define('cart-note', CartNote);

// ========== CART DISCOUNT ==========
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.value = this.input.value;    
    this.btn = this.querySelector('button[name="cart_discount_btn"]');    
    this.remove = this.querySelector('[data-cart-discount-remove]');
    this.error = this.querySelector('.cart_discount_error');
  }

  connectedCallback() {
    this.input.addEventListener('input', this.handleInput.bind(this));
    this.btn.addEventListener('click', this.handleClick.bind(this));
    if(!this.remove) return;
    this.remove.addEventListener('click', this.handleRemove.bind(this));
  }

  handleInput() {
    if(this.error) {
      this.error.classList.add('hidden');
    }
    this.value = this.input.value.trim();
  }

  handleClick(e) {
    e.preventDefault();

    if(!this.value) {
      if(this.error) {
        this.error.classList.remove('hidden');
        this.input.focus();
        return;
      }
    }

    document.dispatchEvent(
      new CustomEvent('discount-btn-click', {
        detail: {
          discount: this.value,          
        },
        bubbles: true, 
        composed: true
      })
    )
  }

  handleRemove(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent('discount-remove-click', {
        detail: {
          discount: ''
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('cart-discount-code', CartDiscount);


//  ================= Side cart drawer (MAIN CART CODE) =================== //

class CartContents extends HTMLElement {
  constructor() {
    super();
    this.onQtyChange = this.onQtyChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDiscountRemove = this.handleDiscountRemove.bind(this);
    this.handleClearCart = this.handleClearCart.bind(this);
    this.inner = this.querySelector('.cart_sidebar_inner') || this.querySelector('.cart_main_content');    
  }

  connectedCallback() {    
    document.addEventListener('cart-quantity-change', this.onQtyChange);
    document.addEventListener('cart-item-remove', this.handleRemove);
    document.addEventListener('discount-btn-click', this.handleClick);
    document.addEventListener('discount-remove-click', this.handleDiscountRemove);
    document.addEventListener('cart-update', updateCart);
    this.addEventListener('click', this.handleClearCart);
  }

  disconnectedCallback() {
    document.removeEventListener('cart-quantity-change', this.onQtyChange);
    document.removeEventListener('cart-item-remove', this.handleRemove);
    document.removeEventListener('discount-btn-click', this.handleClick);
    document.removeEventListener('discount-remove-click', this.handleDiscountRemove);
    this.removeEventListener('click', this.handleClearCart);
  }

  handleClearCart(e) {
    const btn = e.target.closest('[data-cart-clear]');
    if (!btn || !this.contains(btn)) return;

    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;

    if (this.inner) {
      this.inner.classList.add('loading');
    }

    fetch(`${window.Shopify.routes.root}cart/clear.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error('Failed to clear cart');
        return res.json();
      })
      .then(async (cart) => {
        const sections = await fetch(
          `${window.Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
        ).then((res) => res.json());

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { ...cart, sections },
            bubbles: true,
          })
        );
      })
      .catch((err) => {
        console.error('Error: ', err);
        btn.disabled = false;
      })
      .finally(() => {
        this.inner?.classList.remove('loading');
      });
  }

  onQtyChange(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const { value, line } = e.detail;    

    const formData = {
      'line': line,
      'quantity': value,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if(!res.ok) {
        const sections = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`).then((res) => res.json());
        const rawData = {
          'line': line,
          'message': data.message || data.description,
          'sections': sections
        }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: rawData,
            bubbles: true
          })
        )       

        throw new Error(data.description || data.message || 'Request failed');
      }
      return data;
    })
    .then((rawData) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: rawData,
          bubbles: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      this.inner.classList.remove('loading')
    })
  }

  handleRemove(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const { value, line } = e.detail;

    const formData = {
      'line': line,
      'quantity': value,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: data,
          bubbles: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      this.inner.classList.remove('loading');
    })
  } 

  handleClick(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      if(data.discount_codes[0].applicable == false) {
        const error = this.querySelector('.cart_discount_error');
        
        if(error) {
          error.classList.remove('hidden');
          this.input.value = "";
        }

        if(this.inner) {
          this.inner.classList.remove('loading');
        }
      } else {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: data,
            bubbles: true
          })
        )
      }      
    })
    .catch((err) => {
      console.error('Error: ', err)
    })
    .finally(() => {
      this.inner.classList.remove('loading');
    })
  }

  handleDiscountRemove(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'        
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail:data,
          bubble: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      if(this.inner) {
        this.inner.classList.remove('loading');
      }
    })
  }
}

customElements.define('cart-contents', CartContents);

//  ================= Side cart drawer (CART COUNT UPDATE CODE) =================== //
function updateCart(e) {
    const data = e.detail;
    const updatedDrawer = data.sections['cart-drawer'];
    const updatedCartPage = data.sections['cart'];
    const updatedCartBubble = data.sections['cart-bubble'];
    const div = document.createElement('div');
    const pageDiv = document.createElement('div');
    const bubbleDiv = document.createElement('div');
    const errorMsg = e.detail.message;
    const line = e.detail.line;

    // ========== CART DRAWER UPDATE ==========
    if(updatedDrawer) {
      div.innerHTML = updatedDrawer;
    }

    const oldDrawer = document.querySelector('cart-contents');

    if(oldDrawer) {
      const drawerHeader = oldDrawer.querySelector('.cart_sidebar_header');
      const drawerContent = oldDrawer.querySelector('.cart_sidebar_content_wrapper');
      const drawerFooter = oldDrawer.querySelector('.cart_sidebar_items_footer');

      if(drawerHeader) {
        const nextHeader = div.querySelector('.cart_sidebar_header');
        if (nextHeader) drawerHeader.innerHTML = nextHeader.innerHTML;
      }

      if(drawerContent) {        
        drawerContent.innerHTML = div.querySelector('.cart_sidebar_content_wrapper').innerHTML;
        if(errorMsg && line) {
          const errorWrapper = drawerContent.querySelector(`.cart_error[data-line="${line}"]`);

          if(errorWrapper) {
            errorWrapper.innerHTML = `<p>${errorMsg}</p>`
            errorWrapper.removeAttribute('hidden')
          }
        }
      }

      if(drawerFooter) {
        const updatedDrawerFooter = div.querySelector('.cart_sidebar_items_footer');
        if(updatedDrawerFooter) {
          drawerFooter.innerHTML = div.querySelector('.cart_sidebar_items_footer').innerHTML;
        }
      }
    }

    // ========== MAIN CART PAGE CODE ==========
    // Stop if updated cart HTML is missing
      if (!updatedCartPage) return;

      // Create temp container for new cart HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = updatedCartPage;

      // Get existing cart page
      const cartPage = document.querySelector('cart-contents');
      if (!cartPage) return;

     
      const updateSection = (selector) => {
        const oldEl = cartPage.querySelector(selector);
        const newEl = tempDiv.querySelector(selector);

        if (oldEl && newEl) {
          oldEl.innerHTML = newEl.innerHTML;
        }

        return oldEl;
      };

      // Cart update header & content
      updateSection('.cart_main_header');
      const cartContent = updateSection('.cart_main_content');

      // Handle cart error message
      if (cartContent && errorMsg && line) {
        const errorBox = cartContent.querySelector(`.cart_error[data-line="${line}"]`);

        if (errorBox) {
          errorBox.innerHTML = `<p>${errorMsg}</p>`;
          errorBox.hidden = false;
        }
      }


    // ========== CART BUBBLE UPDATE  ==========
    if(updatedCartBubble) {
      bubbleDiv.innerHTML = updatedCartBubble;
    }

    const oldBubble = document.querySelector('.cart-count-text');
    if(oldBubble) {
      oldBubble.innerHTML = bubbleDiv.querySelector('.cart-count-text').innerHTML;
    }
    
  }



/* ======================================================================
   COLLECTION page Filter code Component 
====================================================================== */


// ==================== INFINITE SCROLL   ==================== //

class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.sectionId = this.dataset.sectionId;

    this.isLoading = false;
  }

  connectedCallback() {
    if (!this.button) return;

    this.button.addEventListener("click", () => {
      this.loadProducts();
    });
  }

  loadProducts() {
    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    if (this.isLoading) return;

    this.isLoading = true;
    this.showLoader();
    this.disableFilters();

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set("sections", this.sectionId);

    this.updatePage(url, this.sectionId);
  }

  updatePage(url, id) {
    const wasFilterOpen = this.closest(
      ".main_collection_filters_wrapper",
    )?.classList.contains("active");

    fetch(url.toString())
      .then((res) => res.json())
      .then((htmlString) => {
        const temp = document.createElement("div");
        temp.innerHTML = htmlString[id];

        const newWrapper = temp.querySelector(".main_collection_grid");
        const oldWrapper = document.querySelector(".main_collection_grid");

        if (oldWrapper && newWrapper) {
          const newItems = newWrapper.querySelectorAll(
            ".collection-grid_wrapper",
          );

          if (!newItems.length) {
            this.button.remove();
            return;
          }

          newItems.forEach((item) => {
            item.dataset.revealed = "false";
            oldWrapper.appendChild(item);
          });

          if (window.scrollReveal) {
            const revealItems = Array.from(newItems)
              .map((item) => item.querySelector(".reveal.stagger"))
              .filter(Boolean);

            scrollReveal.staggerBatch(revealItems);
          }

          if (wasFilterOpen) {
            const filterWrapper = document.querySelector(
              ".main_collection_filters_wrapper",
            );
            const gridWrapper = document.querySelector(
              ".main_collection_grid_wrapper",
            );

            if (filterWrapper && gridWrapper) {
              filterWrapper.classList.add("active");
              filterWrapper.removeAttribute("inert");
              gridWrapper.classList.add("padding");
            }
          }

          const newButton = temp.querySelector("infinite-scroll button");
          if (newButton && newButton?.dataset.nextUrl) {
            this.button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            this.button.remove();
          }
        }

        document.dispatchEvent(
          new CustomEvent("collection-grid-update", {
            detail: {
              url: url,
              sectionId: this.sectionId,
            },
          }),
        );
      })
      .catch((err) => {
        console.error("Error: ", err);
      })
      .finally(() => {
        this.enableFilters();
        this.hideLoader();
        this.isLoading = false;
      });
  }

  showLoader() {
    const text = this.button.querySelector(".load_more");
    const loader = this.button.querySelector(".pagination_loader");

    if (!text && !loader) return;

    text.classList.add("hidden");
    loader.classList.remove("hidden");
  }

  hideLoader() {
    const text = this.button.querySelector(".load_more");
    const loader = this.button.querySelector(".pagination_loader");

    if (!text && !loader) return;

    text.classList.remove("hidden");
    loader.classList.add("hidden");
  }

  disableFilters() {
    const filters = this.closest(".main_collection_filters_wrapper");
    if (!filters) return;

    filters.setAttribute("inert", "");
    filters.classList.add("is-loading");
  }

  enableFilters() {
    const filters = this.closest(".main_collection_filters_wrapper");
    if (!filters) return;

    filters.removeAttribute("inert");
    filters.classList.remove("is-loading");
  }
}

customElements.define("infinite-scroll", InfiniteScroll);
 
// ============ FILTER OPEN / CLOSE  ============ //

document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.querySelector(".desktop_filter_icon");
  const drawer = document.querySelector(".c_filter_drawer");
  const drawerInner = drawer?.querySelector(".collection_drawer-wrapper_inner");
  const body = document.body;
  const html = document.documentElement;

  if (!openBtn || !drawer || !drawerInner) return;

  let lastFocusedElement = null;
  let firstFocusableEl = null;
  let lastFocusableEl = null;

  const focusableSelectors = `
    a[href],
    button:not([disabled]),
    textarea,
    input:not([disabled]),
    select,
    [tabindex]:not([tabindex="-1"])
  `;

  const setFocusableElements = () => {
    const focusables = drawer.querySelectorAll(focusableSelectors);
    firstFocusableEl = focusables[0];
    lastFocusableEl = focusables[focusables.length - 1];
  };

  const openDrawer = () => {
    lastFocusedElement = document.activeElement;

    drawer.classList.add("is-active");
    drawer.removeAttribute("inert");
    drawer.setAttribute("aria-hidden", "false");

    body.setAttribute("data-scroll-locked", "true");
    html.classList.add("lenis-stopped");

    setFocusableElements();
    firstFocusableEl?.focus();

    document.addEventListener("keydown", handleKeydown);
  };

  const closeDrawer = () => {
    drawer.classList.remove("is-active");
    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute("inert", "");

    body.removeAttribute("data-scroll-locked");
    html.classList.remove("lenis-stopped");

    lastFocusedElement?.focus();
    document.removeEventListener("keydown", handleKeydown);
  };

  const handleKeydown = (e) => {
    if (e.key === "Escape") {
      closeDrawer();
      return;
    }

    if (e.key !== "Tab") return;

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  };

  // OPEN
  openBtn.addEventListener("click", openDrawer);

  // CLOSE — close button
  drawer.addEventListener("click", (e) => {
    if (e.target.closest(".c_drawer_close")) {
      closeDrawer();
    }
  });

  // CLOSE — backdrop only
  drawer.addEventListener("click", (e) => {
    if (e.target === drawer) {
      closeDrawer();
    }
  });
});


// ============ SORTING  ============ //
class CollectionSorting extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#main_collection_sorting_form');
    this.select = this.querySelector('select[name="sort_by"]');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    if (!this.select) return;

    this.select.addEventListener('change', () => {
      const value = this.select.value;

      this.showLoader();
      
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url)
        .then(() => this.updateURL(url))
        .finally(() => this.hideLoader());
    });
  }

  showLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    loader?.classList.remove('hidden');
    this.select.disabled = true;
  }

  hideLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    loader?.classList.add('hidden');
    this.select.disabled = false;
  }

  async updatePage(url) {
    try {
      const res = await fetch(url.toString());
      const data = await res.json();

      const temp = document.createElement('div');
      temp.innerHTML = data[this.sectionId];

      const newEl = temp.querySelector('.main_collection');
      const oldEl = document.querySelector('.main_collection');

      if (newEl && oldEl) {
        oldEl.innerHTML = newEl.innerHTML;
        
         requestAnimationFrame(() => {
          if (typeof initProductCardSliders === 'function') {
            initProductCardSliders(oldEl);
          }
        });
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: { url, sectionId: this.sectionId }
        })
      );
    } catch (err) {
      console.error('Collection fetch error:', err);
    }
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    history.pushState({}, '', url.toString());
  }
}

customElements.define('product-sorting', CollectionSorting);

// ============ COLLECTION PRODUCT FILTER  ============ //


class Filters extends HTMLElement {
  constructor() {
    super();
    this.loader = document.querySelector('.main_collection_list_wrapper .loader');
    this.collectionGrid = document.querySelector('.main_collection');
    this.btn = this.querySelector('.filters_btn button');
    this.form = this.querySelector('form#c_filters_form');
    this.drawer = document.querySelector('.c_filter_drawer');
    this.activeValues = this.querySelectorAll('.active_values_wrapper a');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {
    if(this.btn) {
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        if(!this.form || !this.collectionGrid) return;

        this.showLoader();
        this.submitForm();
      })
    }    

    if(this.activeValues.length) {
    this.activeValues.forEach((value) => {
      value.addEventListener('click', (e) => {
        e.preventDefault();

        this.showLoader();

        const url = new URL(e.currentTarget.getAttribute('href'), window.location.href);

        this.updateURL(url.toString()),
        this.updatePage(url.toString(), this.sectionId);

      })
    })
  }
  }

  showLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    if(loader) {
      loader.classList.remove('hidden');
    }

    if(this.select) {
      this.select.disabled = true;
    }
  }

  hideLoader() {
    const loader = document.querySelector('.main_collection_list_wrapper .loader');
    if(loader) {
      loader.classList.add('hidden');
    }

    if(this.select) {
      this.select.disabled = false;
    }
  }

  async submitForm() {
    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {      
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams();

    const currentParams = new URLSearchParams(window.location.search);
    const hasSortBy = formData.has('sort_by');

    for(const [key, value] of currentParams.entries()) {
      if(!key.startsWith('filter.v.') && !key.startsWith('filter.p.')) {
        if(key === 'sort_by' && hasSortBy) {
          continue;
        }
        params.append(key,  value);
      }
    }

    for(const [key, value] of formData.entries()) {
      if(value && value != "") {
        if(key === "sort_by") {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      }
    }

    const url = `${window.location.pathname}?${params.toString()}`;

    await this.updateURL(url);
    await this.updatePage(url, this.sectionId);
  }  

  async updateURL(url) {
    history.pushState(null, "", url);
  }

  async updatePage(url, id) {
    const newURL = url.includes('?')
  ? `${url}&sections=${id}`
  : `${url}?sections=${id}`;
    
    fetch(newURL)
    .then((res) => res.json())
    .then((htmlString) => {

      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];

      const newWrapper = temp.querySelector('.main_collection');
      const oldWrapper = document.querySelector('.main_collection');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML;

        requestAnimationFrame(() => {
          if (typeof initProductCardSliders === 'function') {
            initProductCardSliders(oldWrapper);
          }
        });

      }

      const newCount = temp.querySelector('.collection_products_count');
      const oldCount = document.querySelector('.collection_products_count');

      if(oldCount && newCount) {
        oldCount.innerHTML = newCount.innerHTML;
      }

      const newMobileDrawer = temp.querySelector('.c_filter_drawer');
      const oldMobileDrawer = this.drawer;

      if(oldMobileDrawer && newMobileDrawer) {
        oldMobileDrawer.innerHTML = newMobileDrawer.innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )

    })
    .finally(() => {
       this.hideLoader();
       
    })
  }

}

customElements.define('collection-filters', Filters);



// ============= CALL BACK SCRIPT ON PAGE LOAD AND AJAX  ============= //
document.addEventListener('DOMContentLoaded', () => {
  initProductCardSliders();
});


/* ======================================================================
   LOCALIZATION FORM DROPDWON CODE
====================================================================== */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.currencyForm = this.querySelector('#currency_selector_form');
    this.languageForm = this.querySelector('#language_selector_form');

    this.currencyBtns = this.querySelectorAll('.currency_list button');
    this.languageBtns = this.querySelectorAll('.language_list button');
  }

  connectedCallback() {
    if(this.currencyBtns.length) {
      this.currencyBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleCurrencyClick.bind(this));
      })
    }

    if(this.languageBtns.length) {
      this.languageBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleLanguageClick.bind(this));
      })
    }    
  }

  handleCurrencyClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="country_code"]').value = value;
    return;
    this.currencyForm.submit();
  }

  handleLanguageClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="language_code"]').value = value;
    return;
    this.languageForm.submit();
  }
}

customElements.define('localization-form', LocalizationForm);






/* ======================================================================
   RECENTLY VIEWED CODE
====================================================================== */
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'recently-viewed-products';
    this.sectionSelector = '[data-recently-viewed]';

    this.currentHandle = this.dataset.productHandle;
    this.maxProducts = Number(this.dataset.columns) || 4;
    this.aspectRatio = this.dataset.aspectRatio || 'portrait';
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
  }

  connectedCallback() {
    if (!this.currentHandle) return;

    this.updateRecentlyViewed();
    this.displayRecentlyViewedProducts();
  }

  updateRecentlyViewed() {
    let viewed = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    viewed = viewed.filter(handle => handle !== this.currentHandle);
    viewed.unshift(this.currentHandle);

    if (viewed.length > this.maxProducts) {
      viewed = viewed.slice(0, this.maxProducts);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(viewed));
  }

  async displayRecentlyViewedProducts() {
    const section = document.querySelector(this.sectionSelector);
    if (!section) return;

    const handles = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    if (!handles.length) {
      section.style.display = 'none';
      return;
    }

    try {
      const products = await Promise.all(
        handles.map(handle =>
          fetch(`/products/${handle}.js`).then(res => res.json())
        )
      );

      section.innerHTML = `
        <div class="recently_viewed_inner">
          ${products.map(product => this.renderProductCard(product)).join('')}
        </div>
      `;
    } catch (error) {
      console.error('Recently Viewed error:', error);
      section.style.display = 'none';
    }
  }

  renderProductCard(product) {
    if (!product) return '';

    const variant = product.variants[0];
    const price = variant.price;
    const compareAt = variant.compare_at_price;
    const hasSale = compareAt && compareAt > price;

    const image = product.images?.[0] || "";

    let ratio = 100;
    if (this.aspectRatio === 'portrait') ratio = 140;
    if (this.aspectRatio === 'square') ratio = 100;
    if (this.aspectRatio === 'adapt' && image) {
      ratio = 100;
    }

    return `
      <div class="recently_viewed_product">
        <div class="recently_viewed_product_img ratio" style="--aspect-ratio:${ratio}%">
          <a href="/products/${product.handle}" aria-label="${product.title}">
            ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}
          </a>
        </div>

        <div class="recently_viewed_product_info">
          <p>
            <a aria-label="${product.title}" href="/products/${product.handle}">${product.title}</a>
          </p>

          <div class="recently_viewed_product_price">
            <span class="${hasSale ? 'sale_p' : 'regular'}">
              ${Shopify.formatMoney(price, this.moneyFormat)}
            </span>
            ${hasSale ? `<s>${Shopify.formatMoney(compareAt, this.moneyFormat)}</s>` : ''}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('recently-viewed', RecentlyViewed);

/* ======================================================================
   Composite Promotion Hub 
====================================================================== */
class PromoHub extends HTMLElement {
  constructor() {
    super();
    this.activeIndex = -1;
  }

  connectedCallback() {
    this.blocks = [...this.querySelectorAll('.promo-hub-block')];
    this.backgrounds = [...this.querySelectorAll('.promo-hub-bg')];
    this.grid = this.querySelector('.promo-hub-grid');

    if (!this.blocks.length) return;

    /* Desktop interactions only */
    ['pointerover', 'focusin', 'mouseleave', 'keydown'].forEach((type) =>
      this.addEventListener(type, this)
    );

    /* Mobile: activate slide only after user scrolls */
    this.grid?.addEventListener(
      'scroll',
      () => {
        if (!this.isMobile()) return;

        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.setActiveSlide(), 60);
      },
      { passive: true }
    );
  }

  isMobile() {
    return window.innerWidth <= 749;
  }

  handleEvent(event) {
    const block = event.target.closest('.promo-hub-block');

    /* Disable hover/focus behavior on mobile */
    if (this.isMobile() && event.type !== 'keydown') return;

    if (event.type === 'mouseleave') {
      this.reset();
      return;
    }

    if (event.type === 'keydown') {
      this.onKeyDown(event, block);
      return;
    }

    if (block && this.contains(block)) {
      this.activate(this.blocks.indexOf(block));
    }
  }

  onKeyDown(event, block) {
    if (!block) return;

    if (event.key === 'Escape') {
      this.reset();
      block.blur();
      return;
    }

    const move = {
      ArrowRight: 1,
      ArrowLeft: -1,
      ArrowDown: 1,
      ArrowUp: -1
    }[event.key];

    if (!move) return;

    const current = this.blocks.indexOf(block);
    const next = current + move;

    if (next < 0 || next >= this.blocks.length) return;

    event.preventDefault();
    this.blocks[next].focus();

    if (this.isMobile()) {
      this.blocks[next].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

  activate(index) {
    if (index < 0 || index === this.activeIndex) return;

    this.activeIndex = index;
    this.classList.add('has-hover');

    this.blocks.forEach((block, i) => {
      const active = i === index;

      block.classList.toggle('is-active', active);
      block.setAttribute('aria-current', active ? 'true' : 'false');

      this.backgrounds[i]?.classList.toggle('is-active', active);
    });
  }

  setActiveSlide() {
    if (!this.grid || !this.blocks.length) return;

    const gridRect = this.grid.getBoundingClientRect();
    const center = gridRect.left + gridRect.width / 2;

    let closestIndex = 0;
    let minDistance = Infinity;

    this.blocks.forEach((block, index) => {
      const rect = block.getBoundingClientRect();
      const blockCenter = rect.left + rect.width / 2;
      const distance = Math.abs(center - blockCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = index;
      }
    });

    this.activate(closestIndex);
  }

  reset() {
    /* Desktop only reset */
    if (this.isMobile()) return;

    this.activeIndex = -1;
    this.classList.remove('has-hover');

    this.blocks.forEach((block, i) => {
      block.classList.remove('is-active');
      block.setAttribute('aria-current', 'false');

      /* Keep first background visible */
      this.backgrounds[i]?.classList.toggle('is-active', i === 0);
    });
  }
}

if (!customElements.get('promo-hub')) {
  customElements.define('promo-hub', PromoHub);
}

/* ======================================================================
   Scrolling Image Text
====================================================================== */
class ScrollingImageText extends HTMLElement {
  constructor() { super(); this.curr = this.targ = 0; }

  connectedCallback() {
    this.setup = { start:1.1, end: 0.4, back: 0.4, smooth: 0.020 };
       // Start 1.0 = starts at bottom of screen. Increase to start earlier.
       // End 0.0 = finishes at top of screen. Decrease to finish later.
       // back Amount of "overshoot" bounce. 0.1 is subtle, 0.3 is bouncy.
       // smooth Inertia/Smoothness. 0.03 is very heavy/fluid, 0.1 is fast.
    this.init();
    this.obs = new IntersectionObserver(e => {
      this.active = e[0].isIntersecting;
      if (this.active) { this.snap = true; this.render(); }
    });
    this.obs.observe(this);
  }

  init() {
    this.querySelectorAll('[data-parallax-x], [data-parallax-rotate]').forEach(el => {
      if (el.dataset.parallaxX) el.style.setProperty('--parallax-x', el.dataset.parallaxX);
      if (el.dataset.parallaxRotate) el.style.setProperty('--parallax-rotate', el.dataset.parallaxRotate);
    });
  }

  render() {
    if (!this.active) return;

    const rect = this.getBoundingClientRect();
    const winH = window.innerHeight;
    const startPoint = winH * this.setup.start;
    const endPoint = winH * this.setup.end;
    
    // Calculate progress
    this.targ = Math.min(Math.max((startPoint - rect.top) / (startPoint - endPoint), 0), 1);
    
    // Smooth or Snap
    this.curr = this.snap ? this.targ : this.curr + (this.targ - this.curr) * this.setup.smooth;
    this.snap = false;

    // Apply Easing (Overshoot)
    const c1 = this.setup.back;
    const eased = 1 + (c1 + 1) * Math.pow(this.curr - 1, 3) + c1 * Math.pow(this.curr - 1, 2);

    this.style.setProperty('--parallax-progress', eased);
    requestAnimationFrame(() => this.render());
  }

  disconnectedCallback() { if (this.obs) this.obs.disconnect(); }
}

if (!customElements.get('scrolling-image-text')) {
  customElements.define('scrolling-image-text', ScrollingImageText);
}
